import Vue from 'vue'
import * as types from './mutation-types'
import * as https from '@/apis/http'
import * as util from '@/util/util'
import bus from '@/util/eventbus'
// export * from '@/util/mystomp'
const constants = require('@/util/constants')

/**
 * 2. token持久化
 */
export const updatePassportToken = ({ commit }, token) => {
  commit(types.PERSIST_PASSPORT_TOKEN, { token })
}

/**
 * 重新加载页面初始化
 */
export const init = ({ commit, state, dispatch }) => {
  // 1. 加载本地token
  commit(types.INIT)
}

/**
 * 踢掉线
 */
export const kickoff = ({ commit, state, dispatch }) => {
  let uuid = Vue.ls.get(constants.KICKOFF_UUID)
  if (!uuid) {
    uuid = util.uuid();
    Vue.ls.set(constants.KICKOFF_UUID, uuid)
  }
  let topic = state.user.info.uid
  // console.log('uuid:', uuid, ' topic:', topic)
  //
  https.kickoff(uuid, topic, response => {
    // console.log('kickoff success:', response)
  }, error => {
    console.log('kickoff error:', error)
  })
}

/**
 * 客服端登录成功之后，推送到公众号提示用户已经登录
 */
// export const loginSuccess = ({ commit, state, dispatch }) => {
//   //
//   https.loginSuccess(response => {
//     // console.log('loginSuccess:', response)
//   }, error => {
//     console.log('loginSuccess error:', error)
//   })
// }

/**
 * 提前从服务器Redis缓存中加载用户信息，以尽快建立长链接。
 * 与getProfile不冲突
 * 在想出更好解决方案之前，暂时不要注释掉
 * @param {*} param0 
 */
// export const getProfileCache = ({ commit, dispatch }) => {
//   //
//   https.getProfileCache(response => {
//     console.log('getProfileCache:', response)
//     if (response.status_code === 200) {
//       let info = response.data
//       commit(types.PERSIST_USER_INFO_CACHE, { info })
//       // 第一次直接连接，上面定时检测长连接
//       dispatch('mqtt/mqttConnect', {}, { root: true })
//     } else {
//       console.log(response.message)
//     }
//   }, error => {
//     console.log('error', error)
//     bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
//   })
// }

/**
 * 加载用户个人资料
 */
export const getProfile = ({ commit, state, dispatch }) => {
  //
  https.getProfile(response => {
    console.log('getProfile: ', response)
    if (response.status_code === 200) {
      let info = response.data
      commit(types.PERSIST_USER_INFO, { info })
      // 根据角色权限显示隐藏div
      commit(types.UPDATE_SHOW_AUTHORITY)
      // TODO: 定时器连接
      // setInterval(function () {
      //   dispatch('mqtt/mqttConnect', {}, { root: true })
      // }, 10000);
      // 第一次直接连接，上面定时检测长连接
      dispatch('mqtt/mqttConnect', {}, { root: true })
      // validateUntilDate-比较日期，超期通知dashboard弹窗
      let now = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      let endAt = moment(info.validateUntilDate).format('YYYY-MM-DD HH:mm:ss')
      if (!info.enabled || now > endAt) {
        console.log('out of service')
        bus.$emit(constants.EVENT_BUS_OUT_OF_SERVICE, info.validateUntilDate)
      } else {
        bus.$emit(constants.EVENT_BUS_VALIDATE_DATE, info.validateUntilDate)
      }
      // 踢掉其余相同客服端
      kickoff({ commit, state, dispatch })
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log('error', error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 更新个人资料
 */
export const updateProfile = ({ commit, state }, payload) => {
  let username = payload.username
  let password = payload.password
  let nickname = payload.nickname
  let avatar = payload.avatar
  let mobile = payload.mobile
  let email = payload.email
  let description = payload.description
  let welcomeTip = payload.welcomeTip
  https.updateProfile(username, password, nickname, avatar, mobile, email,
    description, welcomeTip, response => {
      console.log('updateProfile', response)
      if (response.status_code === 200) {
        // 持久化用户信息
        let info = response.data
        commit(types.PERSIST_USER_INFO, { info })
      } else {
        bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
      }
    }, error => {
      console.log(error)
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
    })
}

/**
 * 客服给访客做备注：修改访客昵称
 */
export const updateNote = ({ commit, state }, payload) => {
  let uid = payload.uid
  let nickname = payload.nickname
  https.updateNote(uid, nickname, response => {
    // console.log('updateNote', response)
    if (response.status_code === 200) {
      // 更新会话昵称
      commit(types.UPDATE_THREAD_NICKNAME, { uid, nickname })
    } else {
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 查询自动回复历史
 */
export const queryAutoReply = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  https.queryAutoReply(page, size, response => {
    // console.log('queryAutoReply:', response)
    if (response.status_code === 200) {
      let autoReplyList = response.data.content
      commit(types.QUERY_AUTO_REPLY, { autoReplyList })
    } else {
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 设置自动回复内容
 */
// export const updateAutoReply = ({ commit, state }, payload) => {
//   let autoReply = payload.isAutoReply
//   let autoReplyContent = payload.content
//   https.updateAutoReply(autoReply, autoReplyContent, response => {
//     // console.log('updateAutoReply', response)
//     //
//     if (response.status_code === 200) {
//       let info = response.data
//       commit(types.PERSIST_AUTO_REPLY, { info })
//     } else {
//       bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
//     }
//   }, error => {
//     console.log(error)
//     bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
//   })
// }

// 新增-支持图片
export const updateAutoReply2 = ({ commit, state }, payload) => {
  let autoReply = payload.isAutoReply
  let content = payload.content
  let imageUrl = payload.imageUrl
  https.updateAutoReply2(autoReply, content, imageUrl, response => {
    console.log('updateAutoReply', response)
    if (response.status_code === 200) {
      let info = response.data
      commit(types.PERSIST_AUTO_REPLY, { info })
    } else {
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 删除持久化自动回复
 */
export const deleteAutoReply = ({ commit, state }, aid) => {
  //
  https.deleteAutoReply(aid, response => {
    // console.log('deleteAutoReply:', response)
    if (response.status_code === 200) {
      commit(types.DELETE_AUTO_REPLY, { aid })
    } else {
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 设置在线状态
 * @param {*} param0 commit, state
 */
export const setAcceptStatus = ({ commit, state }, status) => {
  //
  https.setAcceptStatus(status, response => {
    // console.log('setAcceptStatus', response)
    if (response.status_code === 200) {
      commit(types.PERSIST_ACCEPT_STATUS, { status })
    } else {
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 设置视频客服 在线状态
 * @param {*} param0 commit, state
 */
export const setWebrtcStatus = ({ commit, state }, status) => {
  //
  https.setWebrtcStatus(status, response => {
    console.log('setWebrtcStatus', response)
    // 
    if (response.status_code === 200) {
      commit(types.PERSIST_WEBRTC_STATUS, { status })
    } else {
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 设置当前会话类型
 */
export const updateChatType = ({ commit, state }, payload) => {
  let type = payload.type
  let object = payload.object
  commit(types.UPDATE_CURRENT_CHAT_TYPE, { type, object })
}

/**
 * 更新当前会话thread
 * @param {*} param0 commit, state
 * @param {*} thread thread
 */
export const updateCurrentThread = ({ commit, state, dispatch }, thread) => {
  let preTid = state.user.current_thread.tid
  let tid = thread.tid
  // 清除未读消息数目
  commit(types.UPDATE_CURRENT_THREAD, { thread })
  if (preTid === tid) {
    console.log('same thread')
    return
  }
  // TODO: 对于本地收到的已经发送送达状态的消息，发送已读状态回执receipt消息
  for (let i = 0; i < state.user.protobufMessages.length; i++) {
    const message = state.user.protobufMessages[i]
    // console.log('message 1:', message)
    if (message.thread.topic === state.user.current_thread.topic
      && message.status != constants.MESSAGE_STATUS_READ
      && (message.user.uid !== state.user.info.uid)) {
      //
      let payload = { mid: message.mid, status: constants.MESSAGE_STATUS_READ, thread: message.thread }
      dispatch('mqtt/sendMessageReceiptProtobuf', payload, { root: true })
    }
  }
  // 通知服务器
  https.updateCurrentThread(preTid, tid, response => {
    // console.log('updateCurrentThread', response)
  }, error => {
    console.log(error)
  })
  // TODO: 判断本地消息条数，如果>0，则不需要重新加载
  // 加载聊天记录
  let payload = { page: 0, size: 10, scroll: true }
  getMessages({ commit, state, dispatch }, payload)
  //
  if (state.right_active_tab === 'crm') {
    // 查询crm信息
    getCustomerInfo({ commit, state })
    // 拉取访客信息
    getVisitorProfile({ commit, state })  
  } else if (state.right_active_tab === 'fingerpints') {
    // 获取用户设备信息
    getFingerPrints({ commit, state })
  } else if (state.right_active_tab === 'commodity') {
    // 拉取商品消息
    getMessagesCommodity({ commit, state })
  }
  // console.log('thread:', thread)
  if (thread.client.includes('web')) {
    getCurrentThreadUrl({ commit, state }, thread.tid)
  }
  // 聊天记录滚动到底部
  bus.$emit(constants.EVENT_BUS_MESSAGE_SCROLL_TO_BOTTOM)
}

// 更新右侧当前活跃tab
export const updateRightActiveTab = ({ commit, state }, tab) => {
  commit(types.UPDATE_RIGHT_ACTIVE_TAB, { tab })
}

// 不提交服务器
export const updateCurrentThread2 = ({ commit, state, dispatch }, thread) => {
  // 清除未读消息数目
  commit(types.UPDATE_CURRENT_THREAD, { thread })
  // TODO: 对于本地收到的已经发送送达状态的消息，发送已读状态回执receipt消息
  for (let i = 0; i < state.user.protobufMessages.length; i++) {
    const message = state.user.protobufMessages[i]
    // console.log('message 2:', message)
    if (message.thread.topic === state.user.current_thread.topic
      && message.status != constants.MESSAGE_STATUS_READ
      && (message.user.uid !== state.user.info.uid)) {
      //
      let payload = { mid: message.mid, status: constants.MESSAGE_STATUS_READ, thread: message.thread }
      dispatch('mqtt/sendMessageReceiptProtobuf', payload, { root: true })
    }
  }
  // TODO: 判断本地消息条数，如果>0，则不需要重新加载
  // 加载聊天记录
  let payload = { page: 0, size: 10, scroll: true }
  getMessages({ commit, state, dispatch }, payload)
  //
  if (state.right_active_tab === 'crm') {
    // 查询crm信息
    getCustomerInfo({ commit, state })
    // 拉取访客信息
    getVisitorProfile({ commit, state })
  } else if (state.right_active_tab === 'fingerpints') {
    // 获取用户设备信息
    getFingerPrints({ commit, state })
  } else if (state.right_active_tab === 'commodity') {
    // 拉取商品消息
    getMessagesCommodity({ commit, state })
  }
  // 聊天记录滚动到底部
  bus.$emit(constants.EVENT_BUS_MESSAGE_SCROLL_TO_BOTTOM)
}

// 持久化当前输入框草稿
export const persistThreadDraft = ({ commit, state }, payload) => {
  let topic = payload.topic
  let content = payload.content
  commit(types.PERSIST_THREAD_DRAFT, { topic, content })
}

// 拉取置顶会话
export const getTopThreads = ({ commit, state }) => {
  //
  https.getTopThreads(0, 20, response => {
    console.log('getTopThreads:', response)
    if (response.status_code === 200) {
      let threadPage = response.data
      for (let i = 0; i < threadPage.length; i++) {
        const thread = threadPage[i]
        commit(types.MARK_TOP_THREAD, { thread })
      }
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log(error)
  })
}

// 会话置顶
export const markThreadTop = ({ commit, state }, thread) => {
  //
  commit(types.MARK_TOP_THREAD, { thread })
  https.markTop(thread.tid, response => {
    // console.log(response)
    // commit(types.MARK_TOP_THREAD, { thread })
  }, error => {
    console.log(error)
  })
}

// 取消会话置顶
export const unmarkThreadTop = ({ commit, state }, thread) => {
  //
  commit(types.UNMARK_TOP_THREAD, { thread })
  https.unmarkTop(thread.tid, response => {
    // console.log(response)
    if (response.status_code === 200) {
      // 
    } else {
      console.log(response.message)
    }
    // commit(types.UNMARK_TOP_THREAD, { thread })
  }, error => {
    console.log(error)
  })
}

// 会话免打扰
export const markThreadNodisturb = ({ commit, state }, thread) => {
  //
  commit(types.MARK_NODISTURB_THREAD, { thread })
  let uid = state.user.info.uid
  https.markNodisturb(uid, thread.tid, response => {
    if (response.status_code === 200) {
      // 
    } else {
      console.log(response.message)
    }
    // console.log(response)
    // commit(types.MARK_NODISTURB_THREAD, { thread })
  }, error => {
    console.log(error)
  })
}

// 取消会话免打扰
export const unmarkThreadNodisturb = ({ commit, state }, thread) => {
  //
  commit(types.UNMARK_NODISTURB_THREAD, { thread })
  let uid = state.user.info.uid
  https.unmarkNodisturb(uid, thread.tid, response => {
    // console.log(response)
    if (response.status_code === 200) {
      // 
    } else {
      console.log(response.message)
    }
    // commit(types.UNMARK_NODISTURB_THREAD, { thread })
  }, error => {
    console.log(error)
  })
}

// 会话未读
export const markThreadUnread = ({ commit, state }, thread) => {
  //
  commit(types.MARK_UNREAD_THREAD, { thread })
  https.markUnread(thread.tid, response => {
    // console.log(response)
    if (response.status_code === 200) {
      // 
    } else {
      console.log(response.message)
    }
    // commit(types.MARK_UNREAD_THREAD, { thread })
  }, error => {
    console.log(error)
  })
}

// 取消会话未读
export const unmarkThreadUnread = ({ commit, state }, thread) => {
  //
  commit(types.UNMARK_UNREAD_THREAD, { thread })
  https.unmarkUnread(thread.tid, response => {
    // console.log(response)
    if (response.status_code === 200) {
      // 
    } else {
      console.log(response.message)
    }
    // commit(types.UNMARK_UNREAD_THREAD, { thread })
  }, error => {
    console.log(error)
  })
}

// 拉取星标会话
export const getStarThreads = ({ commit, state }) => {
  //
  https.getStarThreads(0, 20, response => {
    console.log('getStarThreads:', response)
    if (response.status_code === 200) {
      let threadPage = response.data
      for (let i = 0; i < threadPage.length; i++) {
        const thread = threadPage[i]
        let starType = thread.starType
        commit(types.MARK_STAR_THREAD, { thread, starType })
      }
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log(error)
  })
}

// 星标会话
export const markThreadStar = ({ commit, state }, payload) => {
  //
  let thread = payload.thread
  let starType = payload.starType
  commit(types.MARK_STAR_THREAD, { thread, starType })
  //
  https.markStar(thread.tid, starType, response => {
    // console.log(response)
    if (response.status_code === 200) {
      // 
    } else {
      console.log(response.message)
    }
    // commit(types.MARK_STAR_THREAD, { thread, starType })
  }, error => {
    console.log(error)
  })
}


export const markThreadDeleted = ({ commit, state }, tid) => {
  //
  commit(types.REMOVE_USER_THREAD, { tid })
  //
  // https.markThreadDeleted(tid, response => {
  //   // console.log(response)
  //   if (response.status_code === 200) {
  //     //
  //   } else {
  //     // 报错
  //     bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
  //   }
  // }, error => {
  //   console.log(error)
  //   bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  // })
}

export const unmarkThreadDeleted = ({ commit, state }, tid) => {
  //
  https.unmarkThreadDeleted(tid, response => {
    // console.log(response)
    if (response.status_code === 200) {
      //
    } else {
      // 报错
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 更新当前会话昵称
 */
export const updateCurrentThreadNickname = ({ commit, state }, nickname) => {
  //
  commit(types.UPDATE_CURRENT_THREAD_NICKNAME, { nickname })
}

/**
 * 设置当前排队
 */
export const updateCurrentQueue = ({ commit, state }, queue) => {
  commit(types.UPDATE_CURRENT_QUEUE, { queue })
}

export const updateCurrentBrowse = ({ commit, state }, browse) => {
  commit(types.UPDATE_CURRENT_BROWSE, { browse })
}

export const updateCurrentCustomer = ({ commit, state }, crm) => {
  // 设置当前crm信息
  commit(types.UPDATE_CURRENT_CUSTOMER_INFO, { crm })
  // 缓存crm信息
  commit(types.ADD_CUSTOMER_INFO, { crm })
}

export const updateMessageStatus = ({ commit, state }, payload) => {
  let mid = payload.mid
  let status = payload.status
  // console.log('update:', mid, ' status:', status)
  commit(types.UPDATE_USER_MESSAGE, { mid, status })
}

export const updateThreadDelay = ({ commit, state }, payload) => {
  let tid = payload.tid
  let delay = payload.delay
  // console.log('update:', tid, ' delay:', delay)
  commit(types.UPDATE_THREAD_DELAY, { tid, delay })
}

/**
 * 加载更多聊天记录
 * TODO: 根据会话类型加载聊天记录
 * TODO: 不仅加载此次会话消息，分页加载所有历史会话消息
 * @param {*} param0 commit, state
 */
export const getMessages = ({ commit, state, dispatch }, payload) => {
  //
  let page = payload.page
  let size = payload.size
  // let scroll = payload.scroll
  let thread = state.user.current_thread
  if (thread.type === constants.THREAD_TYPE_CONTACT) {
    // 同事消息
    let cid = state.user.current_thread.topic
    https.getContactMessages(cid, page, size, response => {
      // console.log('contact: ', response)
      if (response.status_code === 200) {
        for (let i = response.data.content.length - 1; i >= 0; i--) {
          const message = response.data.content[i]
          commit(types.ADD_PROTOBUF_MESSAGE, { message })
        }
      } else {
        bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
      }
      // 聊天记录加载完毕
      bus.$emit(constants.EVENT_BUS_MESSAGE_LOADED)
    }, error => {
      // console.log(error)
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
    })
  } else if (thread.type === constants.THREAD_TYPE_GROUP) {
    // 群组消息
    let gid = state.user.current_thread.topic
    https.getGroupMessages(gid, page, size, response => {
      // console.log('group: ', response)
      if (response.status_code === 200) {
        for (let i = response.data.content.length - 1; i >= 0; i--) {
          const message = response.data.content[i]
          commit(types.ADD_PROTOBUF_MESSAGE, { message })
        }
      } else {
        bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
      }
      // 聊天记录加载完毕
      bus.$emit(constants.EVENT_BUS_MESSAGE_LOADED)
    }, error => {
      // console.log(error)
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
    })
  } else if (thread.type === constants.THREAD_TYPE_CHANNEL) {
    // 频道消息
    let cid = state.user.current_thread.topic
    https.getChannelMessages(cid, page, size, response => {
      // console.log('channel: ', response)
      if (response.status_code === 200) {
        for (let i = response.data.content.length - 1; i >= 0; i--) {
          const message = response.data.content[i]
          commit(types.ADD_PROTOBUF_MESSAGE, { message })
        }
      } else {
        bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
      }
      // 聊天记录加载完毕
      bus.$emit(constants.EVENT_BUS_MESSAGE_LOADED)
    }, error => {
      // console.log(error)
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
    })
  } else {
    // if (thread.type === constants.THREAD_TYPE_WORKGROUP ||
    // thread.type === constants.THREAD_TYPE_APPOINTED ||
    // thread.type === constants.THREAD_TYPE_ROBOT)
    //
    if (state.user.current_thread.topic === '') {
      return
    }
    // 根据uid加载聊天记录
    // let uid = state.user.current_thread.topic.split('/')[1] // 访客uid
    // let payload2 = { page: payload.page, size: payload.size, scroll: payload.scroll, uid: uid }
    // getMessagesByUid({ commit, state, dispatch }, payload2)
    // 根据topic加载聊天记录
    let topic = state.user.current_thread.topic
    let payload2 = { page: payload.page, size: payload.size, scroll: payload.scroll, topic: topic }
    getMessagesByTopic({ commit, state, dispatch }, payload2)
  }
}

// 通过uid加载聊天记录
export const getMessagesByUid = ({ commit, state, dispatch }, payload2) => {
  let page = payload2.page
  let size = payload2.size
  let scroll = payload2.scroll
  let uid = payload2.uid
  https.getMessages(uid, page, size, response => {
    console.log('getMessagesByUid', uid, page, size, response)
    if (response.status_code === 200) {
      //
      for (let i = response.data.content.length - 1; i >= 0; i--) {
        const message = response.data.content[i]
        commit(types.ADD_PROTOBUF_MESSAGE, { message })
        // 发送已读回执
        if (message.user.uid !== state.user.info.uid && message.status != constants.MESSAGE_STATUS_READ) {
          let payload = { mid: message.mid, status: constants.MESSAGE_STATUS_READ, thread: message.thread }
          dispatch('mqtt/sendMessageReceiptProtobuf', payload, { root: true })
        }
      }
      // 更新加载更多信息
      let last = response.data.last
      commit(types.UPDATE_LOAD_MESSAGE_PAGE, { last })
      // 聊天记录滚动到底部
      if (scroll) {
        bus.$emit(constants.EVENT_BUS_MESSAGE_SCROLL_TO_BOTTOM)
      }
    } else {
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
    // 聊天记录加载完毕
    bus.$emit(constants.EVENT_BUS_MESSAGE_LOADED)
  }, error => {
    // console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

// TODO: 本地已经存在的消息，避免重复从服务器拉取
// TODO: 在服务器端更新已读状态，防止重复发送已读状态
export const getMessagesByTopic = ({ commit, state, dispatch }, payload2) => {
  //
  let page = payload2.page
  let size = payload2.size
  let scroll = payload2.scroll
  let topic = payload2.topic
  //
  https.getMessagesByTopic(topic, page, size, response => {
    // console.log('getMessagesByTopic', topic, page, size, response)
    if (response.status_code === 200) {
      //
      for (let i = response.data.content.length - 1; i >= 0; i--) {
        const message = response.data.content[i]
        // console.log('message 3:', message)
        commit(types.ADD_PROTOBUF_MESSAGE, { message })
        // 发送已读回执
        if (message.user.uid !== state.user.info.uid && message.status != constants.MESSAGE_STATUS_READ) {
          let payload = { mid: message.mid, status: constants.MESSAGE_STATUS_READ, thread: message.thread }
          dispatch('mqtt/sendMessageReceiptProtobuf', payload, { root: true })
        }
      }
      // 更新加载更多信息
      let last = response.data.last
      commit(types.UPDATE_LOAD_MESSAGE_PAGE, { last })
      // 聊天记录滚动到底部
      if (scroll) {
        bus.$emit(constants.EVENT_BUS_MESSAGE_SCROLL_TO_BOTTOM)
      }
    } else {
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
    // 聊天记录加载完毕
    bus.$emit(constants.EVENT_BUS_MESSAGE_LOADED)
  }, error => {
    // console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

// 获取分页消息
export const getThreadMessages = ({ commit, state, dispatch }, payload) => {
  //
  let page = payload.page
  let size = payload.size
  let scroll = payload.scroll
  let tid = payload.tid
  //
  https.getThreadMessages(tid, page, size, response => {
    // console.log('getThreadMessages', tid, page, size, response)
    if (response.status_code === 200) {
      // 
      for (let i = response.data.content.length - 1; i >= 0; i--) {
        const message = response.data.content[i]
        commit(types.ADD_PROTOBUF_MESSAGE, { message })
        // 发送已读回执
        if (message.user.uid !== state.user.info.uid && message.status != constants.MESSAGE_STATUS_READ) {
          let payload = { mid: message.mid, status: constants.MESSAGE_STATUS_READ, thread: message.thread }
          dispatch('mqtt/sendMessageReceiptProtobuf', payload, { root: true })
        }
      }
      // 更新加载更多信息
      let last = response.data.last
      commit(types.UPDATE_LOAD_MESSAGE_PAGE, { last })
      // 聊天记录滚动到底部
      if (scroll) {
        bus.$emit(constants.EVENT_BUS_MESSAGE_SCROLL_TO_BOTTOM)
      }
    } else {
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
    // 聊天记录加载完毕
    bus.$emit(constants.EVENT_BUS_MESSAGE_LOADED)
  }, error => {
    // console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

// 客服端-查询客服所有未读消息
export const getUnreadMessagesAgent = ({ commit, state, dispatch }, payload) => {
  //
  let flag = true
  commit(types.UPDATE_UNREAD_MESSAGE_STATUS, { flag })
  //
  let page = payload.page
  let size = payload.size
  //
  https.getUnreadMessagesAgent(page, size, response => {
    // console.log('getUnreadMessagesAgent', page, size, response)
    if (response.status_code === 200) {
      //
      for (let i = response.data.content.length - 1; i >= 0; i--) {
        const message = response.data.content[i]
        commit(types.ADD_PROTOBUF_MESSAGE, { message })
        // 发送已读回执
        if (message.user.uid !== state.user.info.uid && message.status != constants.MESSAGE_STATUS_READ) {
          let payload = { mid: message.mid, status: constants.MESSAGE_STATUS_READ, thread: message.thread }
          dispatch('mqtt/sendMessageReceiptProtobuf', payload, { root: true })
        }
      }
      // 更新加载更多信息
      // let last = response.data.last
      // commit(types.UPDATE_LOAD_MESSAGE_PAGE, { last })
      // 聊天记录滚动到底部
      // if (scroll) {
      //   bus.$emit(constants.EVENT_BUS_MESSAGE_SCROLL_TO_BOTTOM)
      // }
    } else {
      console.log('getUnreadMessagesAgent: ', response)
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
    // 聊天记录加载完毕
    // bus.$emit(constants.EVENT_BUS_MESSAGE_LOADED)
    // 更新拉取未读消息状态
    flag = false
    commit(types.UPDATE_UNREAD_MESSAGE_STATUS, { flag })
  }, error => {
    // console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
    // 更新拉取未读消息状态
    flag = false
    commit(types.UPDATE_UNREAD_MESSAGE_STATUS, { flag })
  })
}

/**
 * 调用http-rest接口发送消息
 * @param {*} param0 commit, state
 */
export const sendMessageRest = ({ commit, state }, payload) => {
  //
  let json = payload.json
  https.sendMessageRest(json, response => {
    // console.log('sendMessageRest:', response)
    if (response.status_code === 200) {
      let msgObject = JSON.parse(response.data)
      let message = {
        mid: msgObject.mid,
        content: msgObject.text.content,
        createdAt: msgObject.timestamp,
        client: msgObject.client,
        type: msgObject.type,
        status: constants.MESSAGE_STATUS_STORED,
        thread: msgObject.thread,
        user: msgObject.user
      }
      commit(types.ADD_PROTOBUF_MESSAGE, { message })
    } else {
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 加载历史消息
 * @param {*} param0 commit, state
 */
export const getHistoryMessages = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  https.getHistoryMessages(page, size, response => {
    // console.log(response)
    if (response.status_code === 200) {
      let messages = response.data
      commit(types.PERSIST_MESSAGES, { messages })
    } else {
      // 报错
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 搜索过滤历史消息
 * @param {*} param0 commit, state
 */
export const searchMessageArchive = ({ commit, state }, payload) => {
  //
  commit(types.CLEAR_HISTORY_RECORDS)
  //
  let page = payload.page
  let size = payload.size
  let content = payload.content
  let type = payload.type
  let subDomain = payload.subDomain
  // console.log('searchMessageArchive:', content, type, subDomain)
  https.searchMessageArchive(page, size, content, type, subDomain, response => {
    // console.log('searchMessageArchive:', response)
    if (response.status_code === 200) {
      let messagesArchive = response.data.content
      for (let i = 0; i < messagesArchive.length; i++) {
        const messageString = messagesArchive[i].content;
        let messageObject = JSON.parse(messageString)
        // console.log('thread tid: ', messageObject.thread.tid)
        let thread = messageObject.thread
        commit(types.PERSIST_SEARCH_THREAD, { thread })
      }
      // commit(types.PERSIST_MESSAGES_ARCHIVE, { messagesArchive })
    } else {
      console.log(response.message)
    }
    // 搜索
    searchHistoryThread({ commit, state }, payload)
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 搜索过滤历史消息
 * @param {*} param0 commit, state
 */
export const filterMessage = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  let nickname = payload.nickname
  let createdAtStart = payload.createdAtStart
  let createdAtEnd = payload.createdAtEnd
  let workGroupNickname = payload.workGroupNickname
  let agentRealName = payload.agentRealName
  let client = payload.client
  https.filterMessage(page, size, nickname, createdAtStart, createdAtEnd, workGroupNickname, agentRealName, client, response => {
    // console.log(response)
    if (response.status_code === 200) {
      let messages = response.data
      commit(types.PERSIST_MESSAGES, { messages })
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

// 分页查询客户
export const queryCustomers = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  https.queryCustomers(page, size, response => {
    console.log('query customer:', response)
    if (response.status_code === 200) {
      // 持久化
      let customers = response.data
      commit(types.PERSIST_CUSTOMERS, { customers })
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log('query customer error:', error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

export const getCustomerInfo = ({ commit, state }) => {
  //
  let thread = state.user.current_thread
  if (thread.type === constants.THREAD_TYPE_WORKGROUP ||
    thread.type === constants.THREAD_TYPE_APPOINTED ||
    thread.type === constants.THREAD_TYPE_ROBOT) {
    //
    if (state.user.current_thread.topic === '') {
      return
    }
    let uid = state.user.current_thread.topic.split('/')[1] // 访客uid
    getCustomerInfoByUid({ commit, state }, uid)
  }
}

export const getCustomerInfoByUid = ({ commit, state }, uid) => {
  //
  if (uid === undefined || uid.trim().length === 0) {
    return
  }
  https.getCustomerByUid(uid, response => {
    // console.log('get customer success:', response)
    if (response.status_code === 200) {
      let crm = response.data
      // 设置当前crm信息
      commit(types.UPDATE_CURRENT_CUSTOMER_INFO, { crm })
      // 缓存crm信息
      commit(types.ADD_CUSTOMER_INFO, { crm })
    } else {
      commit(types.CLEAR_CURRENT_CUSTOMER_INFO)
    }
  }, error => {
    // console.log('get customer error:', error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 加载满意度记录
 * @param {*} param0 commit, state
 */
export const getRates = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  //
  https.getRates(page, size, response => {
    // console.log(response)
    if (response.status_code === 200) {
      let rates = response.data
      commit(types.PERSIST_RATES, { rates })
    } else {
      // 报错
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 搜索过滤历史评价
 * @param {*} param0 commit, state
 */
export const filterRate = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  let nickname = payload.nickname
  let createdAtStart = payload.createdAtStart
  let createdAtEnd = payload.createdAtEnd
  let workGroupNickname = payload.workGroupNickname
  let agentRealName = payload.agentRealName
  let client = payload.client
  //
  https.filterRate(page, size, nickname, createdAtStart, createdAtEnd, workGroupNickname, agentRealName, client, response => {
    // console.log(response)
    if (response.status_code === 200) {
      let rates = response.data
      commit(types.PERSIST_RATES, { rates })
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 客服发起评价邀请
 * @param {*} param0 commit, state
 * @param {*} tid tid
 */
export const inviteRate = ({ commit, state }, tid) => {
  //
  //
  https.inviteRate(tid, response => {
    // console.log(response)
    if (response.status_code === 200) {
      // 通知前端
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_SUCCESS, response.message)
    } else {
      // 报错
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 分页获取留言记录
 * @param {*} param0 commit, state
 */
export const getLeaveMessages = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  https.getLeaveMessages(page, size, response => {
    // console.log(response)
    if (response.status_code === 200) {
      //
      let leaveMessages = response.data
      commit(types.PERSIST_LEAVE_MESSAGES, { leaveMessages })
    } else {
      // 报错
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 标记留言回复
 * @param {*} param0 commit, state
 * @param {*} tid tid
 */
export const replyLeaveMessage = ({ commit, state }, payload) => {
  let lid = payload.lid
  let replied = payload.replied
  let reply = payload.reply
  //
  https.replyLeaveMessage(lid, replied, reply, response => {
    // console.log(response)
    if (response.status_code === 200) {
      // 更新本地数据
      let leaveMessage = response.data
      commit(types.UPDATE_LEAVE_MESSAGE, { leaveMessage })
    } else {
      // 报错
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 搜索过滤历史留言
 * @param {*} param0 commit, state
 */
export const filterLeaveMessage = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  let nickname = payload.nickname
  let createdAtStart = payload.createdAtStart
  let createdAtEnd = payload.createdAtEnd
  let workGroupNickname = payload.workGroupNickname
  let agentRealName = payload.agentRealName
  let client = payload.client
  //
  https.filterLeaveMessage(page, size, nickname, createdAtStart, createdAtEnd, workGroupNickname, agentRealName, client, response => {
    // console.log(response)
    if (response.status_code === 200) {
      let leaveMessages = response.data
      commit(types.PERSIST_LEAVE_MESSAGES, { leaveMessages })
    } else {
      // 报错
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 加载满意度记录
 * @param {*} param0 commit, state
 */
export const getHistoryStatus = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  let accessToken = state.passport.token.access_token
  https.getHistoryStatus(page, size, accessToken, response => {
    // console.log(response)
    if (response.status_code === 200) {
      let statuses = response.data
      commit(types.PERSIST_STATUSES, { statuses })
    } else {
      // 报错
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 搜索过滤历史在线状态
 * @param {*} param0 commit, state
 */
export const filterStatus = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  let createdAtStart = payload.createdAtStart
  let createdAtEnd = payload.createdAtEnd
  let agentRealName = payload.agentRealName
  let client = payload.client
  let accessToken = state.passport.token.access_token
  https.filterStatus(page, size, createdAtStart, createdAtEnd, agentRealName, client, accessToken, response => {
    // console.log(response)
    if (response.status_code === 200) {
      let statuses = response.data
      commit(types.PERSIST_STATUSES, { statuses })
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 关闭会话
 * @param {*} param0 commit, state
 * @param {*} tid tid
 */
export const agentCloseThread = ({ commit, state }, tid) => {
  //
  removeClosedThread({ commit, state }, tid)
  //
  https.agentCloseThread(tid, response => {
    // console.log(response)
    if (response.status_code === 200) {
      //
    } else {
      // 报错
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

// 删除已经关闭的会话
export const removeClosedThread = ({ commit, state }, tid) => {
  console.log('removeClosedThread:', tid)
  commit(types.CLOSE_USER_THREAD, { tid })
  commit(types.REMOVE_USER_THREAD, { tid })
  commit(types.REMOVE_ROBOT_THREAD_ONGOING, { tid })
  commit(types.REMOVE_MONITORS, { tid })
}

// 右键点击历史会话中某条会话，重新放到当前会话列表，并添加监听，可收发消息
export const restartThread = ({ commit, state, dispatch }, thread) => {
  // console.log(thread.tid, thread.topic)
  let tid = thread.tid
  commit(types.RESTART_USER_THREAD, { tid })
  // 添加订阅
  let topic = thread.topic
  dispatch('mqtt/mqttSubscribe', topic, { root: true })
  //
  https.restartThread(tid, topic, response => {
    // console.log(response)
  }, error => {
    console.log(error)
  })
}

export const getThreadTags = ({ commit, state }) => {
  let type = 'thread'
  getTags({ commit, state }, type)
}

export const getUserTags = ({ commit, state }) => {
  let type = 'user'
  getTags({ commit, state }, type)
}

/**
 * 获取标签
 */
export const getTags = ({ commit, state }, type) => {
  //
  https.getTags(type, response => {
    // console.log('getTags:', response.data)
    if (response.status_code === 200) {
      // 持久化
      let tags = response.data
      if (type === 'user') {
        commit(types.PERSIST_USER_TAGS, { tags })
      } else if (type === 'thread') {
        commit(types.PERSIST_THREAD_TAGS, { tags })
      }
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 创建标签
 * @param {*} param0 commit, state
 * @param {*} name 标签名
 * @param {*} isRobot 是否智能
 */
export const createTag = ({ commit, state }, payload) => {
  let name = payload.name
  //
  https.createTag(name, response => {
    // console.log(response)
    // 持久化
    if (response.status_code === 200) {
      let tag = response.data
      commit(types.ADD_USER_TAG, { tag })
    } else {
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 删除标签
 * @param {*} param0 commit, state
 * @param {*} id 标签id
 */
export const deleteTag = ({ commit, state }, id) => {
  //
  https.deleteTag(id, response => {
    // console.log(response)
    // 本地删除
    if (response.status_code === 200) {
      let id = response.data
      commit(types.DELETE_USER_TAG, { id })
    } else {
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 接受转接会话本地持久化操作
 * @param {*} param0 commit, state
 */
export const transferAccept = ({ commit, state, dispatch }, message) => {
  // 1.持久化
  let thread = message.thread
  commit(types.ADD_USER_THREAD, { thread })
  // 2.添加订阅
  // let topic = thread.topic
  // // subscribeTopic({ commit, state }, topic)
  // dispatch('stomp/subscribeTopic', topic, { root: true })
}

/**
 * 转接会话本接受本地持久化操作
 * @param {*} param0 commit, state
 */
export const transferAccepted = ({ commit, state, dispatch }, message) => {
  // 1. 从本地存储state中删除thread
  let tid = message.thread.tid
  commit(types.REMOVE_USER_THREAD, { tid })
  // // 2. 取消订阅thread
  // let topic = message.thread.topic
  // // unsubscribeTopic({ commit, state }, topic)
  // dispatch('stomp/unsubscribeTopic', topic, { root: true })
  // 取消当前thread
  commit(types.CLEAR_CURRENT_THREAD)
}

/**
 * 邀请转接会话本地持久化操作
 * @param {*} param0 commit, state
 */
export const inviteAccept = ({ commit, state, dispatch }, message) => {
  // 1.持久化
  let thread = message.thread
  commit(types.ADD_USER_THREAD, { thread })
  // // 2.添加订阅
  // let topic = 'thread.' + thread.tid
  // // subscribeTopic({ commit, state }, topic)
  // dispatch('stomp/subscribeTopic', topic, { root: true })
}

/**
 * 获取当前会话
 * @param {*} param0 commit, state
 */
export const getThreads = ({ commit, state, dispatch }) => {
  // 清理当前会话
  let beforeThreads = state.user.threads
  //
  https.getThreads(response => {
    console.log('getThreads:', response)
    if (response.status_code === 200) {
      // 客服会话
      let agentThreads = response.data.agentThreads
      for (let i = 0; i < agentThreads.length; i++) {
        let thread = agentThreads[i]
        commit(types.INIT_USER_THREAD, { thread })
        // 当前会话
        if (thread.current) {
          updateCurrentThread2({ commit, state, dispatch }, thread)
        }
        // 置顶
        if (thread.top) {
          commit(types.MARK_TOP_THREAD, { thread })
        }
        // 免打扰
        if (thread.nodisturb) {
          commit(types.MARK_NODISTURB_THREAD, { thread })
        }
        // 未读
        if (thread.unread) {
          commit(types.MARK_UNREAD_THREAD, { thread })
        }
      }
      // commit(types.PERSIST_USER_THREADS, { agentThreads })
      // 联系人会话
      let contactThreads = response.data.contactThreads
      for (let i = 0; i < contactThreads.length; i++) {
        const thread = contactThreads[i]
        commit(types.INIT_USER_THREAD, { thread })
        // 置顶
        if (thread.top) {
          commit(types.MARK_TOP_THREAD, { thread })
        }
        // 免打扰
        if (thread.nodisturb) {
          commit(types.MARK_NODISTURB_THREAD, { thread })
        }
        // 未读
        if (thread.unread) {
          commit(types.MARK_UNREAD_THREAD, { thread })
        }
      }
      // 群组会话
      let groupThreads = response.data.groupThreads
      for (let i = 0; i < groupThreads.length; i++) {
        const thread = groupThreads[i]
        commit(types.INIT_USER_THREAD, { thread })
        // 置顶
        if (thread.top) {
          commit(types.MARK_TOP_THREAD, { thread })
        }
        // 免打扰
        if (thread.nodisturb) {
          commit(types.MARK_NODISTURB_THREAD, { thread })
        }
        // 未读
        if (thread.unread) {
          commit(types.MARK_UNREAD_THREAD, { thread })
        }
      }
      // 清除本地会话中不在服务器返回列表中的会话
      for (let i = 0; i < beforeThreads.length; i++) {
        const tid = beforeThreads[i].tid
        let contains = false
        for (let j = 0; j < agentThreads.length; j++) {
          const afterThread = agentThreads[j]
          if (afterThread.tid === tid) {
            contains = true
            // 更新未读数目
            // let unreadCount = beforeThreads[i].unreadCount
            // if (unreadCount > 0) {
            //   commit(types.UPDATE_THREAD_UNREAD_COUNT, { tid, unreadCount })
            // }
          }
        }
        for (let j = 0; j < contactThreads.length; j++) {
          const afterThread = contactThreads[j]
          if (afterThread.tid === tid) {
            contains = true
          }
        }
        for (let j = 0; j < groupThreads.length; j++) {
          const afterThread = groupThreads[j]
          if (afterThread.tid === tid) {
            contains = true
          }
        }
        if (!contains) {
          commit(types.REMOVE_USER_THREAD, { tid })
        }
      }
      // 迁移到外面去，不在此执行
      // 拉取置顶会话
      // getTopThreads({ commit, state })
      // 拉取星标会话
      // getStarThreads({ commit, state })
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log(error)
  })
}

/**
 * 获取联系人会话
 * @param {*} param0 commit, state
 */
export const getContactThread = ({ commit, state }, cid) => {
  //
  https.getContactThread(cid, response => {
    // console.log(response)
    if (response.status_code === 200) {
      let thread = response.data
      commit(types.ADD_USER_THREAD, { thread })
    } else {
      let message = response.message
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 获取群组会话
 * @param {*} param0 commit, state
 */
export const getGroupThread = ({ commit, state }, gid) => {
  //
  https.getGroupThread(gid, response => {
    // console.log(response)
    if (response.status_code === 200) {
      let thread = response.data
      commit(types.ADD_USER_THREAD, { thread })
    } else {
      let message = response.message
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 获取频道会话
 * @param {*} param0 commit, state
 */
export const getChannelThread = ({ commit, state }) => {
  //
  https.getChannelThread(response => {
    // console.log('getChannelThread:', response)
    if (response.status_code === 200) {
      let threadList = response.data
      //
      for (let i = 0; i < threadList.length; i++) {
        const thread = threadList[i]
        commit(types.ADD_USER_THREAD, { thread })
      }
    } else {
      let message = response.message
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 获取工单会话
 * @param {*} param0 commit, state
 */
export const getTicketThread = ({ commit, state }) => {
  //
  https.getTicketThread(response => {
    console.log('getTicketThread:', response)
    if (response.status_code === 200) {
      let threadList = response.data
      //
      for (let i = 0; i < threadList.length; i++) {
        const thread = threadList[i]
        commit(types.ADD_USER_THREAD, { thread })
      }
    } else {
      let message = response.message
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 获取当前机器人会话
 * 
 * @param {*} param0 commit, state
 */
export const getRobotThreads = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  let closed = payload.closed
  //
  https.getRobotThreads(page, size, closed, response => {
    // console.log('getRobotThreads', response)
    if (response.status_code === 200) {
      // 本地持久化
      let threads = response.data
      if (closed) {
        commit(types.PERSIST_ROBOT_THREAD_CLOSED, { threads })
      } else {
        commit(types.PERSIST_ROBOT_THREAD_ONGOING, { threads })
      }
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log(error)
  })
}

/**
 * 获取历史会话
 * 
 * @param {*} param0 commit, state
 */
export const queryThread = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  //
  https.queryThread(page, size, response => {
    // console.log(response)
    if (response.status_code === 200) {
      // 本地持久化
      let histories = response.data
      commit(types.PERSIST_HISTORIES, { histories })
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log(error)
  })
}

// 分页获取某个访客的历史会话记录
export const getHistoryThreads = ({ commit, state }, payload) => {
  //
  let thread = state.user.current_thread
  if (thread.type === constants.THREAD_TYPE_WORKGROUP ||
    thread.type === constants.THREAD_TYPE_APPOINTED ||
    thread.type === constants.THREAD_TYPE_ROBOT) {
    //
    let page = payload.page
    let size = payload.size
    if (state.user.current_thread.topic === '') {
      return
    }
    //
    let uid = state.user.current_thread.topic.split('/')[1] // 访客uid
    https.getHistoryThreads(page, size, uid, response => {
      // console.log(response)
      // 本地持久化
      let histories = response.data
      commit(types.PERSIST_HISTORIES, { histories })
    }, error => {
      console.log(error)
    })
  }
}

// 分页获取当前客服的历史会话记录
export const getThreadHistoryRecords = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  https.getThreadHistoryRecords(page, size, response => {
    console.log('getThreadHistoryRecords:', response)
    if (response.status_code === 200) {
      // 本地持久化
      let history_records = response.data
      if (page >= 1 && history_records.content.length === 0) {
        bus.$emit(constants.EVENT_BUS_NOTIFICATION_INFO, '已经到底，没有更多')
        return
      }
      commit(types.PERSIST_HISTORY_RECORDS, { history_records })
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log(error)
  })
}

/**
 * 搜索过滤历史会话
 * 
 * @param {*} param0 commit, state
 */
export const filterHistoryThread = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  let nickname = payload.nickname
  let createdAtStart = payload.createdAtStart
  let createdAtEnd = payload.createdAtEnd
  let workGroupNickname = payload.workGroupNickname
  let agentRealName = payload.agentRealName
  let client = payload.client
  https.filterHistoryThread(page, size, nickname, createdAtStart, createdAtEnd, workGroupNickname, agentRealName, client, response => {
    // console.log(response)
    if (response.status_code === 200) {
      // 本地持久化
      let histories = response.data
      commit(types.PERSIST_HISTORIES, { histories })
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log(error)
  })
}

/**
 * 搜索过滤历史会话
 * 
 * @param {*} param0 commit, state
 */
export const searchHistoryThread = ({ commit, state }, payload) => {
  //
  let page = payload.page
  let size = payload.size
  let content = payload.content
  https.searchHistoryThread(content, page, size, response => {
    // console.log('searchHistoryThread:', response)
    if (response.status_code === 200) {
      // 本地持久化.CLEAR_HISTORY_RECORDS
      let history_records = response.data
      // commit(types.PERSIST_HISTORIES, { history_records })
      commit(types.PERSIST_SEARCH_THREADS, { history_records })
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log(error)
  })
}

/**
 * 获取监控会话
 * @param {*} param0 commit, state
 */
export const getMonitorThreads = ({ commit, state }) => {
  // let page = payload.page
  // let size = payload.size
  https.getMonitorThreads(response => {
    // console.log('getMonitorThreads:', response)
    if (response.status_code === 200) {
      // 本地持久化
      let monitors = response.data
      commit(types.PERSIST_MONITORS, { monitors })
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log(error)
  })
}

/**
 * 获取质量检查会话
 * @param {*} param0 commit, state
 */
export const getQualityThreads = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  //
  https.getQualityThreads(page, size, response => {
    // console.log(response)
    if (response.status_code === 200) {
      // 本地持久化
      let qualities = response.data
      commit(types.PERSIST_QUALITIES, { qualities })
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log(error)
  })
}

/**
 * 获取当前访客
 * @param {*} param0 commit, state
 */
export const queryQueues = ({ commit, state }, payload) => {
  //
  let page = payload.page
  let size = payload.size
  let successcb = payload.successcb
  let failedcb = payload.failedcb
  https.queryQueues(page, size, response => {
    console.log('queryQueues', response.data)
    if (response.status_code === 200) {
      // 本地持久化
      let queues = response.data.page
      commit(types.PERSIST_USER_QUEUES, { queues })
      //
      let queueCache = response.data.cache
      for (let i = 0; i < queueCache.length; i++) {
        const queue = queueCache[i];
        commit(types.ADD_USER_QUEUE, { queue })
      }
      //
      successcb(queues)
      bus.$emit(constants.EVENT_BUS_QUEUE_LOADED)
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log(error)
    failedcb(error)
    bus.$emit(constants.EVENT_BUS_QUEUE_LOADED)
  })
}

/**
 * 接入排队访客
 * @param {*} param0 commit, state
 */
export const acceptQueue = ({ commit, state, dispatch }, qid) => {
  //
  https.acceptQueue(qid, response => {
    // console.log('acceptQueue', response)
    if (response.status_code === 200) {
      // 1.本地持久化
      commit(types.ACCEPT_USER_QUEUE, { qid })
      // 2.持久化 接入会话
      // let queue = response.data
      // let thread = queue.thread
      // var thread = {
      //   tid: queue.thread.tid,
      //   type: queue.thread.type,
      //   uid: queue.thread.visitor.uid,
      //   nickname: queue.thread.visitor.nickname,
      //   avatar: queue.thread.visitor.avatar,
      //   content: queue.thread.content,
      //   timestamp: queue.thread.timestamp,
      //   unreadCount: queue.thread.unreadCount,
      //   topic: queue.thread.topic,
      //   client: queue.thread.client
      // }
      let threadDTO = response.data
      var thread = {
        tid: threadDTO.tid,
        type: threadDTO.type,
        uid: threadDTO.visitor.uid,
        nickname: threadDTO.visitor.nickname,
        avatar: threadDTO.visitor.avatar,
        content: threadDTO.content,
        timestamp: threadDTO.timestamp,
        unreadCount: threadDTO.unreadCount,
        topic: threadDTO.topic,
        client: threadDTO.client
      }
      commit(types.ADD_USER_THREAD, { thread })
      // 3.添加订阅
      // let topic = thread.topic
      // dispatch('mqtt/subscribe', topic, { root: true })
      //
      // subscribeTopic({ commit, state }, topic)
      // dispatch('stomp/subscribeTopic', topic, { root: true })
    } else {
      console.log(response.message)
      commit(types.IGNORE_USER_QUEUE, { qid })
    }
  }, error => {
    console.log(error)
  })
}

export const ignoreQueue = ({ commit, state, dispatch }, qid) => {
  //
  https.ignoreQueue(qid, response => {
    console.log('ignoreQueue', response)
    if (response.status_code === 200) {
      // 1.本地持久化
      commit(types.IGNORE_USER_QUEUE, { qid })
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log(error)
  })
}

/**
 * 获取全部快捷回复
 * @param {*} param0 commit, state
 */
export const getCuws = ({ commit, state }) => {
  https.getCuws(response => {
    // console.log('getCuws:', response)
    if (response.status_code === 200) {
      let cuws = response.data
      commit(types.PERSIST_CUWS, { cuws })
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log(error)
  })
}

/**
 * 获取子快捷回复
 */
export const getChildrenCuws = ({ commit, state }, categoryId) => {
  commit(types.UPDATE_COMPANY_CURRENT_CUW_CATEGORY_ID, { categoryId })
}

/**
 * 创建快捷回复
 */
export const cuwCreate = ({ commit, state }, payload) => {
  let categoryId = payload.categoryId
  let name = payload.name
  let type = payload.type
  let content = payload.content
  let choices = payload.choices
  let richtext = payload.richtext
  let published = payload.published
  let shortcut = payload.shortcut
  // let imageUrl = payload.imageUrl
  https.cuwCreate(categoryId, name, type, content, choices, richtext, published, shortcut, response => {
    console.log('cuwCreate', response)
    if (response.status_code === 200) {
      let cuw = response.data
      let category = cuw.category
      commit(types.ADD_CUW, { cuw, category })
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log(error)
  })
}

/**
 * 更新快捷回复
 */
export const cuwUpdate = ({ commit, state }, payload) => {
  console.log('cuwUpdate:', payload)
  let id = payload.id
  let name = payload.name
  let type = payload.type
  let content = payload.content
  let choices = payload.choices
  let richtext = payload.richtext
  let published = payload.published
  let shortcut = payload.shortcut
  // let imageUrl = payload.imageUrl
  https.cuwUpdate(id, name, type, content, choices, richtext, published, shortcut, response => {
    console.log('cuwUpdate', response)
    if (response.status_code === 200) {
      let cuw = response.data
      let category = null
      commit(types.UPDATE_CUW, { cuw, category })
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log(error)
  })
}

/**
 * 删除快捷回复
 */
export const cuwDelete = ({ commit, state }, id) => {
  //
  https.cuwDelete(id, response => {
    console.log('cuwDelete:', id, response)
    if (response.status_code === 200) {
      let cuwId = id
      let categoryId = null
      commit(types.DELETE_CUW, { cuwId, categoryId })
      // let cuw = response.data.cuw
      // let category = response.data.category
      // commit(types.DELETE_CUW, { cuw, category })
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log(error)
  })
}

// 查询用户设备信息
export const getFingerPrints = ({ commit, state }) => {
  //
  let thread = state.user.current_thread
  if (thread.type === constants.THREAD_TYPE_WORKGROUP ||
    thread.type === constants.THREAD_TYPE_APPOINTED ||
    thread.type === constants.THREAD_TYPE_ROBOT) {
    if (state.user.current_thread.topic === '') {
      return
    }
    let uid = state.user.current_thread.topic.split('/')[1] // 访客uid
    https.getFingerPrint(uid, response => {
      // console.log('device info:', response)
      // 持久化本地
      if (response.status_code === 200) {
        let fingerPrints = response.data
        commit(types.PERSIST_USER_FINGERPRINTS, { fingerPrints })
      } else {
        // bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
      }
    }, error => {
      // console.log('get device info error:', error)
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
    })
  }
}

// 根据uid拉取访客个人信息
export const getVisitorProfile = ({ commit, state }) => {
  //
  let thread = state.user.current_thread
  if (thread.type === constants.THREAD_TYPE_WORKGROUP ||
    thread.type === constants.THREAD_TYPE_APPOINTED ||
    thread.type === constants.THREAD_TYPE_ROBOT) {
    if (state.user.current_thread.topic === '') {
      return
    }
    let uid = state.user.current_thread.topic.split('/')[1] // 访客uid
    // console.log('uid: ', uid)
    //
    https.getProfileByUid(uid, response => {
      // console.log('getVisitorProfile:', response)
      // 持久化本地
      if (response.status_code === 200) {
        let info = response.data
        commit(types.PERSIST_VISITOR_PROFILE, { info })
      } else {
        // bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
      }
    }, error => {
      // console.log('get device info error:', error)
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
    })
  }
}

// 客服端从聊天记录中分页加载某个用户的商品消息
export const getMessagesCommodity = ({ commit, state }) => {
  // 首先清空之前的，再重新拉取
  commit(types.CLEAR_COMMODITY_MESSAGES)
  // console.log('getMessagesCommodity:', state.user.current_thread)
  let thread = state.user.current_thread
  if (thread.type === constants.THREAD_TYPE_WORKGROUP ||
    thread.type === constants.THREAD_TYPE_APPOINTED ||
    thread.type === constants.THREAD_TYPE_ROBOT) {
    if (state.user.current_thread.topic === '') {
      return
    }
    let uid = state.user.current_thread.topic.split('/')[1] // 访客uid
    // console.log('uid: ', uid)
    //
    https.getMessagesCommodity(uid, 0, 10, response => {
      // console.log('getMessagesCommodity: ', response)
      if (response.status_code === 200) {
        //
        let messages = response.data.content
        commit(types.PERSIST_COMMODITY_MESSAGES, { messages })
      } else {
        bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
      }
    }, error => {
      // console.log(error)
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
    })
  }
}

/**
 * 备注用户信息
 */
export const setNote = ({ commit, state }, payload) => {
  let uid = payload.uid
  let value = payload.value
  //
  https.setNote(uid, value, response => {
    // console.log('setNote', response)
    if (response.status_code === 200) {
      let fingerPrint = response.data
      commit(types.ADD_USER_FINGERPRINT, { fingerPrint })
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log(error)
  })
}

// export const userTag = ({ commit, state }, uid) => {
//   //
//   https.userTag(uid, response => {
//     console.log('userTag', response)
//     //
//     let tags = response.data
//     commit(types.PERSIST_USER_TAGS, { uid, tags })
//   }, error => {
//     console.log(error)
//   })
// }

export const getRoles = ({ commit, state }) => {
  https.getRoles(response => {
    if (response.status_code === 200) {
      let roles = response.data
      commit(types.PERSIST_ROLES, { roles })
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log(error)
  })
}

export const getWorkGroups = ({ commit, state }) => {
  //
  https.getAllWorkGroups((response) => {
    console.log("getAllWorkGroups: ", response);
      let workGroups = response.data
      commit(types.PERSIST_USER_WORKGROUPS, { workGroups })
    },
    (error) => {
      console.log(error);
    }
  );
}

/**
 * 获取客服全部联系人
 * @param {*} param0 commit, state
 */
export const getContacts = ({ commit, state }, payload) => {
  let successcb = payload.successcb
  let failedcb = payload.failedcb
  //
  https.getContacts(response => {
    console.log('getContacts:', response)
    if (response.status_code === 200) {
      // 持久化全部联系人
      let contacts = []
      for (let i = 0; i < response.data.length; i++) {
        const element = response.data[i]
        if (!element.robot && element.username != 'bytedesk_notification') {
          contacts.push(element)
        }
      }
      // 持久化
      commit(types.PERSIST_USER_CONTACTS, { contacts })
      // 成功回调
      successcb(contacts)
      // bus.$emit(constants.EVENT_BUS_CONTACT_LOAD_FINISHED)
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log(error)
    // 失败回调
    failedcb(error)
    // bus.$emit(constants.EVENT_BUS_CONTACT_LOAD_FINISHED)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 分页获取客服账号
 * @param {*} param0 commit, state
 */
export const getAgents = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  let accessToken = state.passport.token.access_token
  https.getAgents(page, size, accessToken, response => {
    // console.log(response)
    if (response.status_code === 200) {
      // 持久化客服账号
      let agents = response.data
      commit(types.PERSIST_AGENTS, { agents })
    } else {
      console.log(response.message)
    }
    //
    bus.$emit(constants.EVENT_BUS_AGENT_LOAD_FINISHED, '')
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_AGENT_LOAD_FINISHED, '')
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 分页获取客服账号
 * @param {*} param0 commit, state
 */
export const getWorkGroupMembers = ({ commit, state }) => {
  let accessToken = state.passport.token.access_token
  https.getWorkGroupMembers(accessToken, response => {
    // console.log(response)
    if (response.status_code === 200) {
      // 持久化客服账号
      let workGroupMembers = response.data
      commit(types.PERSIST_FILTER_WORKGROUP_MEMBERS, { workGroupMembers })
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_AGENT_LOAD_FINISHED, '')
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 分页获取客服账号
 * @param {*} param0 commit, state
 */
// export const getOnlineAgents = ({ commit, state }, payload) => {
//   let page = payload.page
//   let size = payload.size
//   https.getOnlineAgents(page, size, response => {
//     console.log('getOnlineAgents:', response)
//     // 持久化客服账号
//     let agents = response.data
//     commit(types.PERSIST_ONLINE_AGENTS, { agents })
//     //
//     bus.$emit(constants.EVENT_BUS_AGENT_LOAD_FINISHED, '')
//   }, error => {
//     console.log(error)
//     bus.$emit(constants.EVENT_BUS_AGENT_LOAD_FINISHED, '')
//     bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
//   })
// }

export const getOnlineAgents = ({ commit, state }) => {
  // let page = payload.page
  // let size = payload.size
  https.getOnlineAgents(response => {
    // console.log('getOnlineAgents:', response)
    if (response.status_code === 200) {
      // 持久化客服账号
      let agents = response.data
      commit(types.PERSIST_ONLINE_AGENTS, { agents })
    } else {
      console.log(response.message)
    }
    //
    bus.$emit(constants.EVENT_BUS_AGENT_LOAD_FINISHED, '')
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_AGENT_LOAD_FINISHED, '')
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 获取某个访客浏览记录
 * @param {*} param0 commit, state
 */
// export const queryBrowses = ({ commit, state }, payload) => {
//   //
//   let page = payload.page
//   let size = payload.size
//   let uid = payload.uid
//   https.queryBrowses(page, size, uid, response => {
//     // console.log('queryBrowses', response)
//     // 本地持久化
//     let browses = response.data
//     commit(types.PERSIST_USER_BROWSES, { browses })
//   }, error => {
//     console.log(error)
//     bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
//   })
// }

/**
 * 获取浏览访客
 * @param {*} param0 commit, state
 */
// export const queryBrowseAdmin = ({ commit, state }, payload) => {
//   //
//   let page = payload.page
//   let size = payload.size
//   let successcb = payload.successcb
//   let failedcb = payload.failedcb
//   https.queryBrowseAdmin(page, size, response => {
//     // console.log('queryBrowseAdmin', response)
//     if (response.status_code === 200) {
//       // 本地持久化
//       let browses = response.data
//       commit(types.PERSIST_USER_BROWSES, { browses })
//     } else {
//       console.log(response.message)
//     }
//     //
//     successcb(response.data)
//   }, error => {
//     console.log(error)
//     bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
//     failedcb(error)
//   })
// }

export const queryBrowseAdmin2 = ({ commit, state }, payload) => {
  // console.log('queryBrowseAdmin2 payload:', payload)
  //
  let status = payload.status
  let page = payload.page
  let size = payload.size
  let successcb = payload.successcb
  let failedcb = payload.failedcb
  https.queryBrowseAdmin2(status, page, size, response => {
    // console.log('queryBrowseAdmin2', response)
    if (response.status_code === 200) {
      // 本地持久化
      let browses = response.data
      commit(types.PERSIST_USER_BROWSES, { browses })
    } else {
      console.log(response.message)
    }
    //
    successcb(response.data)
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
    failedcb(error)
  })
}

/**
 * 分页拉取当前在线访客
 * 
 * @param {*} param0 
 * @param {*} payload 
 */
export const queryOnlineUsers = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  https.queryOnlineUsers(page, size, response => {
    // console.log('online users response:', response)
    if (response.status_code === 200) {
      for (let i = 0; i < response.data.content.length; i++) {
        let onlineUsers = response.data
        commit(types.PERSIST_ONLINE_USERS, { onlineUsers })
      }
    } else {
      console.log(response.message)
    }
  }, error => {
    console.log('browse error:', error)
  })
}

/**
 * 客服端-根据访客渠道来源client拉取访客, client完全匹配
 * 
 * @param {*} param0 commit, state
 */
export const getVisitorsUniapp = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  let client = 'uniapp'
  let successcb = payload.successcb
  let failedcb = payload.failedcb
  https.getVisitorByClient(page, size, client, response => {
    // console.log(response.data)
    if (response.status_code === 200) {
      // 持久化
      let visitors = response.data
      commit(types.PERSIST_VISITOR_UNIAPP, { visitors })
    } else {
      console.log(response.message)
    }
    //
    successcb(response.data)
  }, error => {
    console.log(error)
    failedcb(error)
  })
}

/**
 * 客服端-根据访客渠道来源client拉取访客, client完全匹配
 * 
 * @param {*} param0 commit, state
 */
export const getVisitorsAndroid = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  let client = 'android'
  let successcb = payload.successcb
  let failedcb = payload.failedcb
  https.getVisitorByClient(page, size, client, response => {
    // console.log(response.data)
    if (response.status_code === 200) {
      // 持久化
      let visitors = response.data
      commit(types.PERSIST_VISITOR_ANDROID, { visitors })
    } else {
      console.log(response.message)
    }
    //
    successcb(response.data)
  }, error => {
    console.log(error)
    failedcb(error)
  })
}

/**
 * 客服端-根据访客渠道来源client拉取访客, client完全匹配
 * 
 * @param {*} param0 commit, state
 */
export const getVisitorsIos = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  let client = 'ios'
  let successcb = payload.successcb
  let failedcb = payload.failedcb
  https.getVisitorByClient(page, size, client, response => {
    // console.log(response.data)
    if (response.status_code === 200) {
      // 持久化
      let visitors = response.data
      commit(types.PERSIST_VISITOR_IOS, { visitors })
    } else {
      console.log(response.message)
    }
    //
    successcb(response.data)
  }, error => {
    console.log(error)
    failedcb(error)
  })
}

/**
 * 客服端-根据访客渠道来源client拉取访客, client完全匹配
 * 
 * @param {*} param0 commit, state
 */
export const getVisitorsFlutter = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  let client = 'flutter'
  let successcb = payload.successcb
  let failedcb = payload.failedcb
  https.getVisitorByClientLike(page, size, client, response => {
    // console.log(response.data)
    if (response.status_code === 200) {
      // 持久化
      let visitors = response.data
      commit(types.PERSIST_VISITOR_FLUTTER, { visitors })
    } else {
      console.log(response.message)
    }
    //
    successcb(response.data)
  }, error => {
    console.log(error)
    failedcb(error)
  })
}

/**
 * 客服端-根据访客渠道来源client拉取访客, client完全匹配
 * 
 * @param {*} param0 commit, state
 */
export const getVisitorsWechat = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  let client = 'wechat'
  let successcb = payload.successcb
  let failedcb = payload.failedcb
  https.getVisitorByClientLike(page, size, client, response => {
    // console.log(response.data)
    if (response.status_code === 200) {
      // 持久化
      let visitors = response.data
      commit(types.PERSIST_VISITOR_WECHAT, { visitors })
    } else {
      console.log(response.message)
    }
    //
    successcb(response.data)
  }, error => {
    console.log(error)
    failedcb(error)
  })
}

/**
 * 当前客服实时统计数据
 */
export const getAgentTodayStatistics = ({ commit, state }) => {
  //
  https.getAgentTodayStatistics(response => {
    // console.log('agent today statistics:', response)
    // 持久化统计数据
    let statistic = response.data
    commit(types.PERSIST_STATISTICS_AGENT_TODAY, { statistic })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 根据客服uid获取实时统计数据
 */
export const getTodayStatisticsByAgentUid = ({ commit, state }, payload) => {
  //
  let uid = payload.uid
  https.getTodayStatisticsByAgentUid(uid, response => {
    // console.log('agent today statistics uid:', response)
    // 持久化统计数据
    let statistic = response.data
    commit(types.PERSIST_STATISTICS_AGENT_UID_TODAY, { uid, statistic })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 获取全部统计数据
 */
export const getStatistics = ({ commit, state }) => {
  //
  https.getStatistics(response => {
    // console.log(response)
    // 持久化统计数据
    let statistic = response.data
    commit(types.PERSIST_STATISTICS, { statistic })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 统计数据详情
 */
export const getStatisticDetails = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  //
  https.getStatisticDetails(page, size, response => {
    // console.log(response)
    // 持久化统计数据
    let detail = response.data
    commit(types.PERSIST_STATISTIC_DETAILS, { detail })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 搜索统计详情
 */
export const filterStatisticDetail = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  let date = payload.date
  let realName = payload.realName
  //
  https.filterStatisticDetail(page, size, date, realName, response => {
    // console.log(response)
    // 持久化统计数据
    let detail = response.data
    commit(types.PERSIST_STATISTIC_DETAILS, { detail })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 获取会话统计数据
 */
export const getStatisticThread = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  //
  https.getStatisticThread(page, size, response => {
    // console.log(response)
    // 持久化统计数据
    let threads = response.data
    commit(types.PERSIST_STATISTICS_THREADS, { threads })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 获取满意度统计数据
 */
export const getStatisticRate = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  //
  https.getStatisticRate(page, size, response => {
    // console.log(response)
    // 持久化统计数据
    let rates = response.data
    commit(types.PERSIST_STATISTICS_RATES, { rates })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 获取帮助文档类别
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const getCategories = ({ commit, state }) => {
  //
  https.getCategories(response => {
    // console.log(response)
    //
    let categories = response.data
    commit(types.PERSIST_CATEGORIES, { categories })
    // commit(types.PERSIST_ROBOT_CATEGORIES, { categories })
    // commit(types.PERSIST_SUPPORT_CATEGORIES, { categories })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 创建类别
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const createCategory = ({ commit, state }, payload) => {
  let parentId = payload.parent_id
  let name = payload.name
  let type = payload.type
  //
  https.createCategory(parentId, name, type, response => {
    // console.log(response)
    //
    let category = response.data
    // if (type === constants.CATEGORY_TYPE_CUW_MINE) {
    let cuw = null
    commit(types.ADD_CUW, { cuw, category })
    // } else {
    //   commit(types.ADD_CATEGORY, { category })
    // }
    // commit(types.ADD_SUPPORT_CATEGORY, { category })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 更新类别
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const updateCategory = ({ commit, state }, payload) => {
  let categoryId = payload.category_id
  let name = payload.name
  //
  https.updateCategory(categoryId, name, response => {
    // console.log('updateCategory:', response)
    //
    let category = response.data
    // if (category.type === constants.CATEGORY_TYPE_CUW_MINE) {
    // console.log('update 1')
    let cuw = null
    commit(types.UPDATE_CUW, { cuw, category })
    // } else {
    //   console.log('update 2')
    //   commit(types.UPDATE_CATEGORY, { category })
    // }
    //
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 删除类别
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const deleteCategory = ({ commit, state }, id) => {
  //
  https.deleteCategory(id, response => {
    console.log('deleteCategory:', id, response)
    //
    // let category = response.data
    // if (category.type === constants.CATEGORY_TYPE_CUW_MINE) {
    let cuwId = null
    let categoryId = id
    commit(types.DELETE_CUW, { cuwId, categoryId })
    // } else {
    //   commit(types.DELETE_CATEGORY, { id })
    // }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 获取answers
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const getRobotAnswers = ({ commit, state }, payload) => {
  let categoryId = payload.categoryId
  let page = payload.page
  let size = payload.size
  //
  https.getRobotAnswers(categoryId, page, size, response => {
    // console.log(response)
    //
    let answers = response.data
    commit(types.PERSIST_ROBOT_ANSWERS, { answers })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 创建智能问答
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const createRobotAnswer = ({ commit, state }, payload) => {
  // let code = payload.code
  let question = payload.question
  let relateds = payload.relateds
  let answer = payload.answer
  let categories = payload.categories
  //
  https.createRobotAnswer(question, relateds, answer, categories, response => {
    // console.log(response)
    //
    let answer = response.data
    commit(types.ADD_ROBOT_ANSWER, { answer })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 更新智能问答
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const updateRobotAnswer = ({ commit, state }, payload) => {
  let aid = payload.aid
  // let code = payload.code
  let question = payload.question
  let relateds = payload.relateds
  let answer = payload.answer
  let categories = payload.categories
  //
  https.updateRobotAnswer(aid, question, relateds, answer, categories, response => {
    // console.log(response)
    //
    let answer = response.data
    commit(types.UPDATE_ROBOT_ANSWER, { answer })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 删除智能问答
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const deleteRobotAnswer = ({ commit, state }, aid) => {
  //
  https.deleteRobotAnswer(aid, response => {
    // console.log(response)
    commit(types.DELETE_ROBOT_ANSWER, { aid })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 获取相似词
 * @param {*} param0 commit, state
 */
export const getRobotSynonyms = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  //
  https.getRobotSynonyms(page, size, response => {
    // console.log(response)
    //
    let synonyms = response.data
    commit(types.PERSIST_ROBOT_SYNONYMS, { synonyms })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 创建相似词
 * @param {*} param0 commit, state
 */
export const createRobotSynonym = ({ commit, state }, payload) => {
  let standard = payload.standard
  let synonyms = payload.synonyms
  //
  https.createRobotSynonym(standard, synonyms, response => {
    // console.log(response)
    // 持久化
    if (response.status_code === 200) {
      let synonym = response.data
      commit(types.ADD_ROBOT_SYNONYM, { synonym })
    } else {
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 创建相似词
 * @param {*} param0 commit, state
 */
export const updateRobotSynonym = ({ commit, state }, payload) => {
  let sid = payload.sid
  let standard = payload.standard
  let synonyms = payload.synonyms
  //
  https.updateRobotSynonym(sid, standard, synonyms, response => {
    // console.log(response)
    // 持久化
    if (response.status_code === 200) {
      let synonym = response.data
      commit(types.UPDATE_ROBOT_SYNONYM, { synonym })
    } else {
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 删除相似词
 * @param {*} param0 commit, state
 */
export const deleteRobotSynonym = ({ commit, state }, sid) => {
  //
  https.deleteRobotSynonym(sid, response => {
    // console.log(response)
    // 持久化
    if (response.status_code === 200) {
      commit(types.DELETE_ROBOT_SYNONYM, { sid })
    } else {
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 获取敏感词
 * @param {*} param0 commit, state
 */
export const getTaboos = ({ commit, state }, payload) => {
  //
  let page = payload.page
  let size = payload.size
  //
  https.getTaboos(page, size, response => {
    console.log('getTaboos:', response)
    if (response.status_code === 200) {
      let taboos = response.data.content
      commit(types.PERSIST_TABOOS, { taboos })
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 搜索分公司
 * @param {*} param0 commit, state
 */
export const filterCompanies = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  let name = payload.name
  let accessToken = state.passport.token.access_token
  https.filterCompanies(page, size, name, accessToken, response => {
    // console.log(response)
    // 持久化分公司
    let companies = response.data
    commit(types.PERSIST_COMPANIES, { companies })
    //
    bus.$emit(constants.EVENT_BUS_COMPANY_LOAD_FINISHED, '')
  }, error => {
    console.log(error)
  })
}

/**
 * 获取省市
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const getRegions = ({ commit, state }) => {
  let accessToken = state.passport.token.access_token
  https.getRegions(accessToken, response => {
    // console.log(response)
    // 持久化省市
    let regions = response.data
    commit(types.PERSIST_REGIONS, { regions })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 分页获取分公司
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const getCompanies = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  let accessToken = state.passport.token.access_token
  https.getCompanies(page, size, accessToken, response => {
    // console.log(response)
    // 持久化分公司
    let companies = response.data
    commit(types.PERSIST_COMPANIES, { companies })
    //
    bus.$emit(constants.EVENT_BUS_COMPANY_LOAD_FINISHED, '')
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_COMPANY_LOAD_FINISHED, '')
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 创建分公司
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const createCompany = ({ commit, state }, payload) => {
  let name = payload.name
  let description = payload.description
  let regions = payload.selectedRegions
  let accessToken = state.passport.token.access_token
  https.createCompany(name, description, regions, accessToken, response => {
    // console.log(response)
    // 持久化分公司
    let company = response.data
    commit(types.ADD_COMPANY, { company })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 更新分公司
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const updateCompany = ({ commit, state }, payload) => {
  let cid = payload.cid
  let name = payload.name
  let description = payload.description
  let regions = payload.selectedRegions
  let accessToken = state.passport.token.access_token
  https.updateCompany(cid, name, description, regions, accessToken, response => {
    // console.log(response)
    // 持久化分公司
    let company = response.data
    commit(types.UPDATE_COMPANY, { company })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 删除分公司
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const deleteCompany = ({ commit, state }, cid) => {
  let accessToken = state.passport.token.access_token
  https.deleteCompany(cid, accessToken, response => {
    // console.log(response)
    // 持久化分公司
    let cid = response.data
    commit(types.DELETE_COMPANY, { cid })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 分页搜索拉黑访客
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const searchBlocks = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  let content = payload.content
  https.searchBlock(content, page, size, response => {
    // console.log(response)
    //
    let blocks = response.data
    commit(types.PERSIST_BLOCKS, { blocks })
    //
    bus.$emit(constants.EVENT_BUS_BLOCKED_LOADED)
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_BLOCKED_LOADED)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 分页获取拉黑访客
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const getBlocks = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  https.getBlocks(page, size, response => {
    // console.log(response)
    //
    let blocks = response.data
    commit(types.PERSIST_BLOCKS, { blocks })
    //
    bus.$emit(constants.EVENT_BUS_BLOCKED_LOADED)
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_BLOCKED_LOADED)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 更新当前block用户
 */
export const updateCurrentBlock = ({ commit, state, dispatch }, block) => {
  //
  commit(types.UPDATE_CURRENT_BLOCK, { block })
  // 加载聊天记录
  let uid = block.blockedUser.uid
  let payload2 = { page: 0, size: 100, scroll: true, uid: uid }
  getMessagesByUid({ commit, state, dispatch }, payload2)
  // // 查询crm信息
  // getCustomerInfo({ commit, state })
  // // 获取用户设备信息
  // getFingerPrints({ commit, state })
}

/**
 * 添加黑名单
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const addBlock = ({ commit, state }, payload) => {
  // 关闭并删除本地当前用户会话thread
  let tid = state.user.current_thread.tid
  agentCloseThread({ commit, state }, tid)
  // 被拉黑用户uid
  let uid = payload.uid
  // 备注
  let note = payload.note
  // 会话类型
  let type = state.user.current_thread.type
  // 唯一id：客服uid 或 技能组wid
  let uuid = state.user.current_thread.topic.split('/')[0]
  https.addBlock(uid, note, type, uuid, response => {
    // console.log(response)
    if (response.status_code === 200) {
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_SUCCESS, response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 取消当前用户黑名单
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const removeBlock = ({ commit, state }, bid) => {
  https.removeBlock(bid, response => {
    // console.log(response)
    if (response.status_code === 200) {
      commit(types.REMOVE_CURRENT_BLOCK, { bid })
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_SUCCESS, response.message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 获取全部群组
 * @param {*} param0 commit, state
 */
export const getGroups = ({ commit, state }) => {
  //
  https.getGroups(response => {
    // console.log('getGroups:', response)
    // 本地持久化
    let groups = response.data
    commit(types.PERSIST_USER_GROUPS, { groups })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 获取群组全部成员
 * @param {*} param0 commit, state
 */
export const getGroupMembers = ({ commit, state }, payload) => {
  let gid = payload
  //
  https.getGroupMembers(gid, response => {
    // console.log(response)
    //
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 创建群组
 * @param {*} param0 commit, state
 */
export const createGroup = ({ commit, state }, payload) => {
  let nickname = payload.nickname
  let type = constants.GROUP_TYPE_GROUP
  let selectedContacts = payload.selectedContacts
  //
  https.createGroup(nickname, type, selectedContacts, response => {
    // console.log(response)
    // 本地持久化
    let group = response.data
    commit(types.ADD_USER_GROUP, { group })
    // FIXME: 在stomp里面重复通知，待优化
    bus.$emit(constants.EVENT_BUS_GROUP_ADDED, group)
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 更新群组: 群名称等
 * @param {*} param0 commit, state
 */
export const updateGroupNickname = ({ commit, state }, payload) => {
  let gid = payload.gid
  let nickname = payload.nickname
  //
  https.updateGroupNickname(gid, nickname, response => {
    // console.log(response)
    //
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 更新群组公告
 * @param {*} param0 commit, state
 */
export const updateGroupAnnouncement = ({ commit, state }, payload) => {
  let gid = payload.gid
  let nickname = payload.nickname
  //
  https.updateGroupAnnouncement(gid, nickname, response => {
    // console.log(response)
    //
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 更新群组简介
 * @param {*} param0 commit, state
 */
export const updateGroupDescription = ({ commit, state }, payload) => {
  let gid = payload.gid
  let nickname = payload.nickname
  //
  https.updateGroupDescription(gid, nickname, response => {
    // console.log(response)
    //
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 踢人
 * @param {*} param0 commit, state
 */
export const kickGroupMember = ({ commit, state }, payload) => {
  let gid = payload.gid
  let uid = payload.uid
  //
  https.kickGroupMember(gid, uid, response => {
    // console.log(response)
    //
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 禁言
 * @param {*} param0 commit, state
 */
export const muteGroupMember = ({ commit, state }, payload) => {
  let gid = payload.gid
  let uid = payload.uid
  //
  https.muteGroupMember(gid, uid, response => {
    // console.log(response)
    //
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 解散群组
 * @param {*} param0 commit, state
 */
export const dismissGroup = ({ commit, state }, payload) => {
  let gid = payload.gid
  //
  https.dismissGroup(gid, response => {
    // console.log(response)
    //
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 搜索过滤群组
 * @param {*} param0 commit, state
 */
export const filterGroup = ({ commit, state }, payload) => {
  let keyword = payload
  //
  https.filterGroup(keyword, response => {
    // console.log(response)
    //
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 清空token
 * @param {*} param0 token
 */
export const clearToken = ({ commit, state }) => {
  localStorage.removeItem('access_token')
  Vue.ls.remove(constants.ACCESS_TOKEN)
  commit(types.LOGOUT)
}

/**
 * 修改边栏颜色
 * @param {*} color 颜色值
 */
export const changeSidebarColor = ({ commit, state }, color) => {
  commit(types.CHANGE_SIDEBAR_COLOR, { color })
}

export const persistNoticeBrowse = ({ commit, state }, browse) => {
  commit(types.PERSIST_NOTICE_BROWSES, { browse })
}

export const persistQueue = ({ commit, state }, queue) => {
  commit(types.ADD_USER_QUEUE, { queue })
}

export const removeQueue = ({ commit, state }, qid) => {
  commit(types.ACCEPT_USER_QUEUE, { qid })
}

export const addNotice = ({ commit, state }, notice) => {
  commit(types.ADD_NOTICE, { notice })
}

export const updateCurrentNoticeBrowse = ({ commit, state }, browse) => {
  commit(types.UPDATE_CURRENT_NOTICE_BROWSES, { browse })
}

export const getNotices = ({ commit, state }, payload) => {
  //
  commit(types.CLEAR_NOTICES)
  //
  let page = payload.page
  let size = payload.size
  //
  https.queryNotices(page, size, response => {
    // console.log('notices:', response)
    for (let i = 0; i < response.data.content.length; i++) {
      const notice = response.data.content[i]
      commit(types.ADD_NOTICE, { notice })
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
  //
  https.queryWorkGroupNotices(page, size, response => {
    // console.log('notices wg:', response)
    for (let i = 0; i < response.data.content.length; i++) {
      const notice = response.data.content[i]
      commit(types.ADD_NOTICE, { notice })
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

export const updateCurrentNotice = ({ commit, state }, notice) => {
  commit(types.UPDATE_CURRENT_NOTICE, { notice })
}

// 待办任务
export const addTodo = ({ commit, state }, todo) => {
  commit(types.ADD_TODO, { todo })
}

// 从服务器拉取待办任务
export const getTodos = ({ commit, state }, payload) => {
  //
  commit(types.CLEAR_TODOS)
  //
  let page = payload.page
  let size = payload.size
  //
  https.getTodos(page, size, response => {
    // console.log('todos:', response)
    for (let i = 0; i < response.data.content.length; i++) {
      const todo = response.data.content[i]
      commit(types.ADD_TODO, { todo })
    }
    bus.$emit(constants.EVENT_BUS_TODO_LOADED)
  }, error => {
    // console.log(error)
    bus.$emit(constants.EVENT_BUS_TODO_LOADED)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

// 创建待办任务
export const createTodo = ({ commit, state }, payload) => {
  let title = payload.title
  let content = payload.content
  let attachments = payload.attachments
  let timestamp = payload.timestamp
  //
  https.createTodo(title, content, attachments, timestamp, response => {
    // console.log('create todo:', response)
    let todo = response.data
    commit(types.ADD_TODO, { todo })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

// 更新待办任务
export const updateTodo = ({ commit, state }, payload) => {
  let tid = payload.tid
  let title = payload.title
  let content = payload.content
  let attachments = payload.attachments
  let timestamp = payload.timestamp
  //
  https.updateTodo(tid, title, content, attachments, timestamp, response => {
    console.log('update todo:', response)
    if (response.status_code === 200) {
      let todo = response.data
      commit(types.UPDATE_TODO, { todo })
    } else {
      let message = response.message
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, message)
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

// 删除待办任务
export const deleteTodo = ({ commit, state }, payload) => {
  let id = payload.id
  //
  https.deleteTodo(id, response => {
    // console.log('delete todo:', response)
    //
    commit(types.DELETE_TODO, { id })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

export const updateCurrentTodo = ({ commit, state }, todo) => {
  commit(types.UPDATE_CURRENT_TODO, { todo })
}

/**
 * 登入更新状态
 * @param {*} param0 commit
 * @param {*} payload state
 */
export const updateLogin = ({ commit, state }) => {
  // console.log('action updateLogin')
  // 1. 通知服务器
  https.updateLogin(response => {
    // console.log(response)
    if (response.status_code === 200) {
      //
    }
  }, error => {
    console.log(error)
  })
}

/**
 * 退出登录
 * @param {*} param0 commit
 * @param {*} payload state
 */
export const logout = ({ commit, state }) => {
  // console.log('action logout')
  // 1. 通知服务器
  //
  https.logout(response => {
    // console.log(response)
    if (response.status_code === 200) {
      // 2. 清除本地登录状态
      clearToken({ commit, state })
      // 3. 跳转登录页面
      bus.$emit(constants.EVENT_BUS_LOGOUT, 'logout')
    }
  }, error => {
    console.log(error)
    // 2. 清除本地登录状态
    clearToken({ commit, state })
    // 3. 跳转登录页面
    bus.$emit(constants.EVENT_BUS_LOGOUT, 'logout')
  })
}

/**
 * 保存当前main view, 当收到消息时判断当前main view是否为chat，如果否，则弹窗提示新消息
 */
export const changeCurrentMainView = ({ commit, state }, view) => {
  //
  commit(types.CHANGE_CURRENT_MAIN_VIEW, { view })
}

export const updateCurrentOnlineUser = ({ commit, state }, user) => {
  //
  commit(types.UPDATE_CURRENT_ONLINE_USER, { user })
}

export const updateCurrentMonitorThread = ({ commit, state, dispatch }, thread) => {
  // 取消订阅
  // let preTopic = state.user.current_monitor_thread.topic
  // dispatch('mqtt/mqttUnsubscribe', preTopic, { root: true })
  // 添加订阅
  let currentTopic = thread.topic
  dispatch('mqtt/mqttSubscribe', currentTopic, { root: true })
  // 设置当前监控会话
  commit(types.UPDATE_CURRENT_MONITOR_THREAD, { thread })
  // 设置当前会话
  updateCurrentThread({ commit, state, dispatch }, thread)
  // 加载聊天记录
  // if (state.user.current_monitor_thread.topic === '') {
  //   return
  // }
  // let uid = state.user.current_monitor_thread.topic.split('/')[1] // 访客uid
  // let payload2 = { page: 0, size: 100, scroll: true, uid: uid }
  // getMessagesByUid({ commit, state, dispatch }, payload2)
}

// 设置是否显示底部统计数据
export const updateShowBottomStatistics = ({ commit, state }, show) => {
  commit(types.UPDATE_SHOW_BOTTOM_STATISTICS, { show })
}

// 设置是否显示超时提醒
export const updateShowOutOfTime = ({ commit, state }, show) => {
  commit(types.UPDATE_SHOW_OUT_OF_TIME, { show })
}

// 设置是否显示输入联想
export const updateShowInputTips = ({ commit, state }, show) => {
  commit(types.UPDATE_SHOW_INPUT_TIPS, { show })
}

//  设置是否检测是否绑定公众号
export const updateQueryMpQrcodeUrl = ({ commit, state }, show) => {
  commit(types.UPDATE_QUERY_MPQRCODE_URL, { show })
}

//  是否显示网络断开恢复提示
export const updateShowNetworkStatus = ({ commit, state }, show) => {
  commit(types.UPDATE_SHOW_NETWORK_STATUS, { show })
}

// 设置视频客服状态
export const updateWebrtcStarted = ({ commit, state }, show) => {
  commit(types.UPDATE_WEBRTC_STARTED, { show })
}

// 用户是否绑定公众号
export const updateWechatMpBinded = ({ commit, state }, binded) => {
  commit(types.UPDATE_WECHAT_MP_BINDED, { binded })
}

// 查询此客服账号 - 公众号离线消息推送状态
export const getWechatMpPushStatus = ({ commit, state }) => {
  let uid = Vue.ls.get(constants.USER_INFO_UID) //state.user.info.uid
  if (uid === null) {
    return
  }
  console.log('getWechatMpPushStatus:', uid)
  https.getMpPushStatus(uid, response => {
    console.log('getMpPushStatus:', response)
    let enabled = response.data
    commit(types.UPDATE_WECHAT_MP_PUSH_ENABLED, { enabled })
    Vue.ls.set(constants.SHOULD_WECHAT_MP_PUSH, enabled)
  }, error => {
    console.log('getMpPushStatus:', error)
  })
}

// 取消/启用此客服账号-公众号离线消息推送
export const updateWechatMpPushStatus = ({ commit, state }, flag) => {
  let uid = state.user.info.uid
  console.log('updateWechatMpPushStatus:', uid)
  https.switchMpPush(uid, flag, response => {
    console.log('switchMpPush:', response)
    let enabled = flag
    commit(types.UPDATE_WECHAT_MP_PUSH_ENABLED, { enabled })
    Vue.ls.set(constants.SHOULD_WECHAT_MP_PUSH, enabled)
  }, error => {
    console.log('switchMpPush:', error)
  })
}

// 设置当前工单ticket
export const updateCurrentTicket = ({ commit, state, dispatch }, ticket) => {
  //
  commit(types.UPDATE_CURRENT_TICKET, { ticket })
  // 设置当前会话
  let thread = state.user.current_ticket.thread
  let preTid = state.user.current_thread.tid
  let tid = thread.tid
  // 清除未读消息数目
  commit(types.UPDATE_CURRENT_THREAD, { thread })
  // 对于本地收到的已经发送送达状态的消息，发送已读状态回执receipt消息
  for (let i = 0; i < state.user.protobufMessages.length; i++) {
    const message = state.user.protobufMessages[i]
    if (message.thread.tid === state.user.current_thread.tid
      && message.status != constants.MESSAGE_STATUS_READ
      && (message.user.uid !== state.user.info.uid)) {
      //
      let payload = { mid: message.mid, status: constants.MESSAGE_STATUS_READ, thread: message.thread }
      dispatch('mqtt/sendMessageReceiptProtobuf', payload, { root: true })
    }
  }
  // 通知服务器
  https.updateCurrentThread(preTid, tid, response => {
    // console.log('updateCurrentThread', response)
  }, error => {
    console.log(error)
  })
  // 加载聊天记录
  let payload = { page: 0, size: 10, scroll: true, tid: tid }
  getThreadMessages({ commit, state, dispatch }, payload)
}

// 下列工单相关函数待优化
// 待我回复-工单
export const getTicketForMeReply = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  let successcb = payload.successcb
  let failedcb = payload.failedcb
  https.getForMeReply(page, size, response => {
    // console.log('getForMeReply:', response)
    let tickets = response.data
    commit(types.ADD_FOR_ME_TO_REPLY_TICKET, { tickets })
    // for (let i = 0; i < response.data.content.length; i++) {
    //   const ticket = response.data.content[i]
    //   commit(types.ADD_TICKET, { ticket })
    // }
    successcb(response)
  }, error => {
    console.log('error:', error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
    failedcb(error)
  })
}
// 等待回复(待对方回复)-工单
export const getTicketTobeReplied = ({ commit, state }, payload) => {
  //
  // commit(types.CLEAR_TICKETS)
  //
  let page = payload.page
  let size = payload.size
  let successcb = payload.successcb
  let failedcb = payload.failedcb
  https.getToBeReplied(page, size, response => {
    // console.log('getToBeReplied:', response)
    let tickets = response.data
    commit(types.ADD_TO_BE_REPLIED_TICKET, { tickets })
    // for (let i = 0; i < response.data.content.length; i++) {
    //   const ticket = response.data.content[i]
    //   commit(types.ADD_TICKET, { ticket })
    // }
    successcb(response)
  }, error => {
    console.log('error:', error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
    failedcb(error)
  })
}

// 获取客服已解决工单
export const getTicketDone = ({ commit, state }, payload) => {
  //
  // commit(types.CLEAR_TICKETS)
  //
  let page = payload.page
  let size = payload.size
  let successcb = payload.successcb
  let failedcb = payload.failedcb
  https.getDone(page, size, response => {
    // console.log('getDone:', response)
    let tickets = response.data
    commit(types.ADD_DONE_TICKET, { tickets })
    // for (let i = 0; i < response.data.content.length; i++) {
    //   const ticket = response.data.content[i]
    //   commit(types.ADD_TICKET, { ticket })
    // }
    successcb(response)
  }, error => {
    console.log('error:', error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
    failedcb(error)
  })
}

// 获取客服已忽略工单
export const getTicketIgnore = ({ commit, state }, payload) => {
  //
  // commit(types.CLEAR_TICKETS)
  //
  let page = payload.page
  let size = payload.size
  let successcb = payload.successcb
  let failedcb = payload.failedcb
  https.getIgnore(page, size, response => {
    // console.log('getIgnore:', response)
    let tickets = response.data
    commit(types.ADD_IGNORED_TICKET, { tickets })
    // for (let i = 0; i < response.data.content.length; i++) {
    //   const ticket = response.data.content[i]
    //   commit(types.ADD_TICKET, { ticket })
    // }
    successcb(response)
  }, error => {
    console.log('error:', error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
    failedcb(error)
  })
}

// 获取访客已关闭工单
export const getTicketClosed = ({ commit, state }, payload) => {
  //
  let page = payload.page
  let size = payload.size
  let successcb = payload.successcb
  let failedcb = payload.failedcb
  https.getClosed(page, size, response => {
    // console.log('getClosed:', response)
    let tickets = response.data
    commit(types.ADD_CLOSED_TICKET, { tickets })
    // 
    successcb(response)
  }, error => {
    console.log('error:', error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
    failedcb(error)
  })
}

export const ignoreTicket = ({ commit, state }, tid) => {
  //
  https.ignoreTicket(tid, response => {
    //
    console.log('ignore ticket:', response)
    commit(types.DO_IGNORE_TICKET, { tid })
  }, error => {
    console.log('error:', error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

export const doneTicket = ({ commit, state }, tid) => {
  //
  https.doneTicket(tid, response => {
    //
    console.log('done ticket:', response)
    commit(types.DO_DONE_TICKET, { tid })
  }, error => {
    console.log('error:', error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

// export const claimTicket = ({ commit, state }, tid) => {
//   //
//   https.claimTicket(tid, response => {
//     //
//     console.log('claim ticket:', response)
//   }, error => {
//     console.log('error:', error)
//     bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
//   })
// }

/**
 * 分页获取会话小结
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const querySummaries = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  https.querySummaries(page, size, response => {
    // console.log(response)
    //
    let summaries = response.data
    commit(types.PERSIST_SUMMARIES, { summaries })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 分页获取意见反馈
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const queryFeedbacks = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  https.queryFeedbacks(page, size, response => {
    // console.log(response)
    //
    let feedbacks = response.data
    commit(types.PERSIST_FEEDBACKS, { feedbacks })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 分页获取在线状态
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const queryStatuses = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  https.getHistoryStatus(page, size, response => {
    // console.log(response)
    //
    let statuses = response.data
    commit(types.PERSIST_STATUSES, { statuses })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 分页获取 -自定义表情
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const queryEmojis = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  let type = payload.type
  let username = state.user.info.username
  https.getUploads(page, size, type, username, response => {
    // console.log('getUploads emojis:', response)
    if (response.status_code === 200) {
      //
      let emojis = response.data
      commit(types.PERSIST_SELF_EMOJIS, { emojis })
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

export const addEmoji = ({ commit, state }, emojiUrl) => {
  // 
  // let emoji = Object.assign({}, payload)
  let emoji = {
    fileUrl: emojiUrl
  }
  commit(types.ADD_SELF_EMOJIS, { emoji })
}

export const updateEmoji = ({ commit, state }, payload) => {
  // 
  // commit(types.UPDATE_SELF_EMOJIS, { emoji })
}

export const deleteEmoji = ({ commit, state }, id) => {
  // 
  https.deleteUpload(id, response => {
    //
    if (response.status_code === 200) {
      commit(types.DELETE_SELF_EMOJIS, { id })
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 分页获取 自定义图片
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const queryImages = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  let type = payload.type
  let username = state.user.info.username
  https.getUploads(page, size, type, username, response => {
    // console.log('getUploads Images:', response)
    if (response.status_code === 200) {
      let images = response.data
      commit(types.PERSIST_SELF_IMAGES, { images })
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

export const addImage = ({ commit, state }, imageUrl) => {
  // 
  // let image = Object.assign({}, payload)
  let image = {
    fileUrl: imageUrl
  }
  commit(types.ADD_SELF_IMAGES, { image })
}

export const updateImage = ({ commit, state }, payload) => {
  // 
  // commit(types.UPDATE_SELF_EMOJIS, { emoji })
}

export const deleteImage = ({ commit, state }, id) => {
  // 
  https.deleteUpload(id, response => {
    if (response.status_code === 200) {
      commit(types.DELETE_SELF_IMAGES, { id })
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

/**
 * 分页获取 自定义文件
 * @param {*} param0 params
 * @param {*} payload payload
 */
export const queryFiles = ({ commit, state }, payload) => {
  let page = payload.page
  let size = payload.size
  let type = payload.type
  let username = state.user.info.username
  https.getUploads(page, size, type, username, response => {
    // console.log('getUploads files:', response)
    //
    let files = response.data
    commit(types.PERSIST_SELF_FILES, { files })
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}

export const addFile = ({ commit, state }, payload) => {
  // 
  let file = Object.assign({}, payload)
  commit(types.ADD_SELF_FILES, { file })
}

export const updateFile = ({ commit, state }, payload) => {
  // 
  // commit(types.UPDATE_SELF_EMOJIS, { emoji })
}

export const deleteFile = ({ commit, state }, payload) => {
  // 
  // commit(types.DELETE_SELF_EMOJIS, { emoji })
}

// 百度翻译api接口
export const baiduTranslate = ({ commit, state }, payload) => {
  // 
  let mid = payload.mid
  let q = payload.q
  let from = payload.from
  let to = payload.to
  let successcb = payload.successcb
  let failedcb = payload.failedcb
  https.baiduTranslate(mid, q, from, to, response => {
    // console.log('baiduTranslate success:', response)
    if (response.status_code === 200) {
      // 翻译聊天记录
      if (mid.length > 0) {
        let dataObject = JSON.parse(response.data)
        let src = dataObject.trans_result[0].src
        let dst = dataObject.trans_result[0].dst
        // console.log('baiduTranslate src:', src, ' dst:', dst)
        // 
        let content = src + '<br/>翻译:' + dst
        commit(types.UPDATE_MESSAGE_ADD_TRANSLATE, { mid, content })
        // 聊天记录滚动到底部
        // bus.$emit(constants.EVENT_BUS_MESSAGE_SCROLL_TO_BOTTOM)
      } else {
        // 翻译输入文字
      }
    } else {
      bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
    }
    successcb(response)
  }, error => {
    console.log('baiduTranslate error:', error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
    failedcb(error)
  })
}

/**
 * 更新网络连接状态
 * 
 * @param {*} param0 
 * @param {*} payload 
 */
export const updateNetworkStatus = ({ commit, state, dispatch }, payload) => {
  let connectionStatus = payload.status
  commit(types.UPDATE_NETWORK_CONNECTION, { connectionStatus })
  // 通知更新mqtt状态
  dispatch('mqtt/updateMqttNetworkStatus', payload, { root: true })
}

export const getCurrentThreadUrl = ({ commit, state }, tid) => {
  // 
  // console.log('getCurrentThreadUrl:', tid)
  https.getThreadUrl(tid, response => {
    console.log('getCurrentThreadUrl:', tid, response)
    if (response.status_code === 200) {
      // let dataObject = JSON.parse(response.data)
      let url = response.data.url
      let preUrl = response.data.preUrl
      let title = response.data.title
      // 
      commit(types.UPDATE_CURRENT_THREAD_URL, { url, preUrl, title })
    } else {
      // 清空
      let url = ''
      let preUrl = ''
      let title = ''
      // 
      commit(types.UPDATE_CURRENT_THREAD_URL, { url, preUrl, title })
    }
  }, error => {
    console.log(error)
    bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
  })
}


//
// export const getTicketCreatedByMe = ({ commit, state }, payload) => {
//   //
//   commit(types.CLEAR_TICKETS)
//   //
//   let page = payload.page
//   let size = payload.size
//   https.createdByMe(page, size, response => {
//     //
//     console.log('createdByMe:', response)
//     for (let i = 0; i < response.data.content.length; i++) {
//       const ticket = response.data.content[i]
//       commit(types.ADD_TICKET, { ticket })
//     }
//   }, error => {
//     console.log('error:', error)
//     bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
//   })
// }

//
// export const getTicketProcessingByMe = ({ commit, state }, payload) => {
//   //
//   commit(types.CLEAR_TICKETS)
//   //
//   let page = payload.page
//   let size = payload.size
//   https.processingByMe(page, size, response => {
//     //
//     console.log('processingByMe:', response)
//     for (let i = 0; i < response.data.content.length; i++) {
//       const ticket = response.data.content[i]
//       commit(types.ADD_TICKET, { ticket })
//     }
//   }, error => {
//     console.log('error:', error)
//     bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
//   })
// }

// export const getTicketUnclaim = ({ commit, state }, payload) => {
//   //
//   commit(types.CLEAR_TICKETS)
//   //
//   let page = payload.page
//   let size = payload.size
//   https.unclaim(page, size, response => {
//     //
//     console.log('unclaim:', response)
//     for (let i = 0; i < response.data.content.length; i++) {
//       const ticket = response.data.content[i]
//       commit(types.ADD_TICKET, { ticket })
//     }
//   }, error => {
//     console.log('error:', error)
//     bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
//   })
// }

/**
 * 创建敏感词
 * @param {*} param0 commit, state
 */
// export const createTaboo = ({ commit, state }, payload) => {
//   let standard = payload.standard
//   let synonyms = payload.synonyms
//   //
//   https.createTaboo(standard, synonyms, response => {
//     // console.log(response)
//     // 持久化
//     if (response.status_code === 200) {
//       let taboo = response.data
//       commit(types.ADD_TABOO, { taboo })
//     } else {
//       bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
//     }
//   }, error => {
//     console.log(error)
//     bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
//   })
// }

/**
 * 创建敏感词
 * @param {*} param0 commit, state
 */
// export const updateTaboo = ({ commit, state }, payload) => {
//   let sid = payload.sid
//   let standard = payload.standard
//   let synonyms = payload.synonyms
//   //
//   https.updateTaboo(sid, standard, synonyms, response => {
//     // console.log(response)
//     // 持久化
//     if (response.status_code === 200) {
//       let taboo = response.data
//       commit(types.UPDATE_TABOO, { taboo })
//     } else {
//       bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
//     }
//   }, error => {
//     console.log(error)
//     bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
//   })
// }

/**
 * 删除敏感词
 * @param {*} param0 commit, state
 */
// export const deleteTaboo = ({ commit, state }, tid) => {
//   //
//   https.deleteTaboo(tid, response => {
//     // console.log(response)
//     // 持久化
//     if (response.status_code === 200) {
//       commit(types.DELETE_TABOO, { tid })
//     } else {
//       bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, response.message)
//     }
//   }, error => {
//     console.log(error)
//     bus.$emit(constants.EVENT_BUS_NOTIFICATION_ERROR, error)
//   })
// }
